import LocalizedStrings from "react-localization";
import i18n from "src/i18n";

export const localStrings = new LocalizedStrings({
  en: {
    common: {
      // message
      alert: {
        sessionExpired: "The session has expired.",
        serverError:
          "An error has occurred to the service. Please try again later. (Contact the administrator if this problem persists.)",
        // success: {
        //   findPasswordViaMail: `We've sent you an email containing a temporary password. Please change your password from My Account agter login`
        // },
        invalidData: "Data does not exist",
        failPayment:
          " Failed to change the payment cycle. Please contact our customer service.",
        enterRequired: "Enter in the required fields",
        failedToSave: "Failed to save the changes. Please try again.",

        noticePaypal: {
          eco: "Basic and Plus plans are only available for overseas customers. If you are based in Korea, please select the Premium plan. The Wrapsody eCo team will contact you to help you to customize your subscription plan.",
          wrapsody:
            "Basic and Plus plans are only available for overseas customers. If you are based in Korea, please select the Premium plan. The Wrapsody team will contact you to help you to customize your subscription plan.",
        },
        internetConnect: "Internet disconnected. Try again in a moment.",
        limitExcess: "Your card was declined. You went over your card limit.",
        changeCard: "The payment card change has been completed.",
        cancelCard: "Your cancellation request has been completed.",
        overPromotionCode: "Promotion Code length exceeded.",
        sameManager:
          "You did not enter the manager, or it is the same manager.",
      },
      tooltip: {
        clear: "Clear",
        showPassword: "Show password",
        hidePassword: "Hide password",
      },
      add: "Add",
      cancelBtn: "Cancel",
      okBtn: "OK",
      startBtn: "Start",
      deleteBtn: "Delete",
      modifyBtn: "Modify",
      more: "More",
      goBackBtn: "Go back",
      backToHome: "Back to Home",
      vat: "*10% VAT not included",
      addBtn: "Add",
      edit: "Edit",
      card: "Debit or Credit Card",
      changeCard: "Change the payment card",
      korea: "Republic of Korea",
      others: "Other countries",
      person: "per person",
      close: "Close",
      product: "Product",
      application: "Application",
      selected: "Selected:",
      items: "items",
      time: {
        sec: "sec(s) ago",
        min: "min(s) ago",
        hour: "hour(s) ago",
        day: "day(s) ago",
      },
    },
    home: {
      tabs: {
        all: "All",
        dataSecurity: "Data Security",
        documentManagement: "Document Management",
        supplyChainSecurity: "Collaboration Platform",
        privacyDetection: "Data Visibility",
        cloudSecurity: "Cloud Security",
        phishingTraining: "Phishing Training",
        secureMessenger: "Secure Messenger",
      },
      title: "Explore Cloud Products",
      subTitle: {
        1: "From phishing simulation training, to content management, and comprehensive document security solutions,",
        2: "protect your organization’s information quickly and efficiently with Fasoo Cloud Services.",
      },
      consultingBtn: "Contact Us",
      productInfo: {
        title: "Product",
        btn: {
          learnMore: "Learn More",
          select: "Select",
          startNow: "Start Now",
          startFree: "Start for Free",
        },
        features: "Features",
        dspWord: "Advanced Data-Centric Security",
        WRAPSODY: {
          name: "Wrapsody",
          word: "The Next Generation of Enterprise Content Management",
          description:
            "Essential content management platform for AI, turning documents and data into assets.",
          moreInfo: {
            description: {
              1: "Wrapsody is an essential platform for both document security and productivity in the AI era, enabling organizations to consolidate all documents and collaboration history as corporate assets.",
              2: "It encrypts and stores all documents securely, minimizing security concerns.",
              3: "Additionally, it manages redundant, outdated, and trivial data, solving data fragmentation issues for AI learning.",
            },
            subTitle:
              "Essential content management platform for AI, turning documents and data into assets.",
            features: {
              1: "Real-time document encryption regardless of location",
              2: "Document-specific access control and usage restrictions",
              3: "Backup and restore options against ransomware threats",
            },
          },
        },
        WRAPSODY_ECO: {
          name: "Wrapsody eCo",
          word: "All-in-One Zero Trust External Collaboration Platform",
          description:
            "Manage data security across your supply chain with document-level access controls.",
          moreInfo: {
            description: {
              1: "Say goodbye to inconvenient and insecure collaboration.",
              2: "With Wrapsody eCo, you can easily collaborate with external parties such as contractors and freelancers by creating project-based workgroups.",
              3: "Customize access permissions for key documents like drawings and contracts to ensure airtight data security within your supply chain.",
            },
            subTitle:
              "Manage data security across your supply chain with document-level access controls.",
            features: {
              1: "Project-based workgroup creation and external member invitation",
              2: "Secure document sharing without complex approval processes",
              3: "Integration with Outlook, Dropbox, and other collaboration tools",
            },
          },
        },
        FIRESIDE: {
          name: "Fireside",
          description:
            "Secure, content-driven messenger that protects data and streamlines collaboration.",
          word: "The All-in-One Secure Enterprise Messaging App",
          moreInfo: {
            description: {
              1: "Every organization must ensure the secure handling of sensitive information while enabling efficient collaboration.",
              2: "Fireside, a next-generation content-centric secure messenger, helps teams collaborate more safely and efficiently.",
              3: "It encrypts messages and file data, automatically removes sensitive content, and allows seamless communication without security concerns.",
            },
            subTitle:
              "Secure, content-driven messenger that protects data and streamlines collaboration.",
            features: {
              1: "End-to-end encryption for messages and documents",
              2: "Automatic removal of sensitive information and keywords",
              3: "Screenshot prevention and screen watermarking",
            },
          },
        },
        DSPM: {
          name: "Fasoo DSPM",
          description:
            "Visualize data security status in the cloud and minimize potential security threats.",
          word: "NextGen Data Security Posture Management",
          moreInfo: {
            description: {
              1: "With Fasoo DSPM, you can identify and manage redundant, unused, and unnecessary data within your storage systems.",
              2: "It also allows you to monitor compliance with regulations such as the Personal Information Protection Act, GDPR, and HIPAA at both the storage and data levels.",
              3: "Eliminate security blind spots and stay ahead of potential threats.",
            },
            subTitle:
              "Visualize data security status in the cloud and minimize potential security threats.",
            features: {
              1: "Data lineage for complete visibility of data flows",
              2: "Fast and accurate storage security assessment",
              3: "Robust compliance management processes",
            },
          },
        },
        FED: {
          name: "FED-N",
          word: "Zero Trust Document Security Solution",
          description:
            "Zero trust document security solution encrypting documents across diverse environments.",
          moreInfo: {
            description: {
              1: "Document security is fundamental to data protection, especially in commonly used PC environments.",
              2: "FED-N encrypts documents in real-time across various environments based on a zero-trust model.",
              3: "It offers flexible policy management and detailed access controls to handle exceptions securely.",
              4: "#",
            },
            subTitle:
              "Zero trust document security solution encrypting documents across diverse environments.",
            features: {
              1: "Real-time automatic encryption for multi-format documents",
              2: "Supports diverse formats including images and CAD files",
              3: "Flexible document-level policy management",
            },
          },
        },
        FC_BR: {
          name: "FC-BR",
          word: "Real-time Document Backup Solution",
          description:
            "Real-time document backup solution optimized for ransomware defense.",
          moreInfo: {
            subTitle:
              "Real-time document backup solution optimized for ransomware defense.",
            description: {
              1: "As cyberattacks increase, backing up corporate documents is more crucial than ever.",
              2: "FC-BR provides next-generation, real-time backup based on individual documents instead of scheduled tasks.",
              3: "It automatically backs up documents when edited or closed, ensuring continuous protection and enabling quick recovery with file previews.",
            },
            features: {
              1: "Real-time automatic backup optimized for ransomware defense",
              2: "Backup policies based on corporate rules",
              3: "Preview and quick recovery of backup files",
            },
          },
        },
        FSP: {
          name: "FSP",
          description:
            "Prevent information leakage during the printing and distribution of documents.",
          word: "Reliable Print Security for Safe Document Handling",
          moreInfo: {
            description: {
              1: "In today’s business environment, printouts remain one of the most vulnerable points of security.",
              2: "FSP secures printed documents by controlling print permissions, tracking print logs, and offering comprehensive print management.",
              3: "It ensures safe handling of printouts, especially for sensitive information.",
            },
            subTitle:
              "Prevent information leakage during the printing and distribution of documents.",
            features: {
              1: "Detailed tracking of print logs and content",
              2: "Visible and invisible watermark options",
              3: "Masking of key terms and personal information",
            },
          },
        },
        FSS: {
          name: "FSS",
          description:
            "Prevent information leaks via screen capture and recording across work environments.",
          word: "Screen Capture Protection for Business Environments",
          moreInfo: {
            subTitle:
              "Prevent information leaks via screen capture and recording across work environments.",
            description: {
              1: "Screens displaying sensitive information are often neglected despite being major security blind spots.",
              2: "FSS protects against screen capture and screen recording attempts in any work environment.",
              3: "It also logs capture attempts to respond effectively to potential information leaks.",
            },

            features: {
              1: "Blocks various screen capture attempts",
              2: "Provides visible and invisible watermarks",
              3: "Logs and manages screen capture attempts and history",
            },
          },
        },
        FDR: {
          name: "Fasoo Data Radar",
          description:
            "Identify and manage personal data across storage systems with advanced post-processing.",
          word: "Personal Data Identification & Management",
          moreInfo: {
            subTitle:
              "Identify and manage personal data across storage systems with advanced post-processing.",
            description: {
              1: "To tackle data leaks, organizations must identify, classify, and monitor all internal data.",
              2: "FDR detects and locates important unstructured data across multiple storage locations, manages permissions, tracks usage, and applies tailored security policies to vulnerable data.",
              3: "#",
            },
            features: {
              1: "Complete visibility of personal data across storage systems",
              2: "Full compliance with regulations",
              3: "Real-time inspection and versatile post-processing options",
            },
          },
        },
      },
    },
    error: {
      notFoundPage: {
        title: "Page not found.",
        subTitle:
          "The requested page cannot be found. The addresss was typed incorrectly,\nor the page is either deleted or moved. ",
        goToMainBtn: {
          eco: "Move to Wrapsody eCo Cloud",
          wrapsody: "Move to Wrapsody Cloud",
        },
      },
    },
    //leftMenu
    navBar: {
      leftMenu: {
        siteManagement: "Site Management",
        paymentHistory: "Payment History",
      },
      home: {
        mainFeatures: "Main Features",
        productPurchase: "Product Purchase",
        inquiry: "Inquiry",
        company: "Company",
        console: "Console",
      },
      companyName: "© Fasoo Co., Ltd.",
      myAccount: {
        fieldname: "My Account",
        logout: "Logout",
        basicInfo: "Details",
        withDrawal: "Delete Account",
        name: "Name",
        edit: "Edit",
        companyName: "Company Name",
        email: "Email",
        password: "Password",
        popUp: {
          commonCheckMsg: "Failed to save the changes. Please try again.",
          changeEmail: {
            title: "Change Email Address",
            enterEmail: "New email address",
            confirmEmailAddress: "Confirm email address",
            password: "Password",
            checkMsg1: "Please enter new email address.",
            checkMsg2: "Please confirm new email address.",
            checkMsg3: "Invalid email address.",
            checkMsg4: "Same as the current email.",
            checkMsg5: "Email address has been successfully changed.",
            checkMsg6: "Email addresses do not match.",
            checkMsg7: "Please enter your password.",
            checkMsg8: "Email address do not match.",
          },
          changePassword: {
            title: "Change Password",
            enterCurrentPassword: "Current Password",
            enterNewPassword: "New Password",
            confirmPassword: "Confirm Password",
            checkMsg1: "Please enter current password.",
            checkMsg2: "Please enter new password.",
            checkMsg3: "Please enter confirm password.",
            checkMsg4:
              "Password must be between 6 and 16 characters in length including at least one uppercase and lowercase alphabetic, numeric, and special character.",
            checkMsg5: "Passwords do not match.",
            checkMsg6: "Password has been successfully changed.",
            usedPassword: "Recently-used passwords cannot be re-used.",
          },
          changeName: {
            title: "Edit Name",
            enterName: "New Name",
            checkMsg1: "Please enter new name.",
            checkMsg2: "The entered name is too short.",
            checkMsg3: "Same as the current name.",
            checkMsg4: "Name has been successfully changed.",
          },
          withDrawal: {
            title: "Delete Account",
            withDrawalInfo: "User account with active site cannot be deleted.",
            withDrawalInfo_2: "Please delete a site and try again.",
            leaveMember:
              "Are you sure you want to delete your Fasoo Cloud Portal account?",
            leaveOk: "The user is no longer a member of this service.",
          },
        },
      },
      notifications: {
        title: "Notifications",
        mark: "Mark all as read",
        close: "Don't show this again today.",
      },
      contact: {
        QnA: "Q&A",
        contactSupport: "Contact Support",
        customerCenter: "Customer Center",
        FAQ: "FAQ",
        cloudCs: "Cloud Support Center",
      },
    },
    //로그인
    logIn: {
      title: "User Login",
      userEmail: "Email address",
      password: "Password",
      rememberId: "Remember my ID",
      findPassword: "Forgot password?",
      goToLoginBtn: "Login",
      checkMember: "Not a member?",
      goToSignUp: "Sign up now",
      enterUserId: "Enter your user ID",
      enterCompanyName: "Enter your Company Name",
      enterUserEmail: "Enter your user email",
      enterPassword: "Enter your password",
      enterName: "Enter your name",
      invalidUser: "Invalid user ID or password.",
      successMsg: "Welcome! You have successfully logged in.",
      //회원가입
      signUp: {
        title: "Sign Up",
        email: "Email address",
        emailCheckMsg: "Email must not exceed {0} characters.",
        name: "Name",
        nameCheckMsg: "Name must not exceed {0} characters.",
        companyName: "Company Name",
        password: "Password",
        confirmPassowrd: "Confirm Password",
        enterConfirmPassowrd: "Confirm password",
        passwordHint: "8-16 characters with numbers, A-Z, a-z, and symbols",
        agreement1: "I agree to the",
        agreement2: " Terms of Service",
        agreement3: " and the",
        agreement4: " Privacy Policy",
        agreement5: "",
        goToSignUpBtn: "Sign up",
        checkMember: "Already a member?",
        goToLogin: "Login",
        invalidEmail: "Invalid email address.",
        agreement:
          "Please agree to the Terms of Service and the Privacy Policy.",
        validEmail: "valid email address.",
        invalidEmailFormat: "Please enter a valid email address.",
        usedId: "Invalid email address.",
        regexPassword:
          "Password must be between 6 and 16 characters in length including at least one uppercase and lowercase alphabetic, numeric, and special character.",
        validPassword: "valid Password.",
        invalidPasswordFormat:
          "8-16 characters with numbers, A-Z, a-z, and symbols",
        invalidPassword: "Passwords do not match.",
        completed: "Now you are a member of Fasoo Cloud.",
        completedTitle: "Registration Completed",

        joinBox: {
          title_1: "Welcome to",
          title_2: "Fasoo Cloud",
          title_3: "Sign-up Page",
          description_1: "Sign-up for Fasoo Cloud integrated",
          description_2: "membership, so you can",
          description_3: "conveniently use various Fasoo",
          description_4: "Cloud products with a single ID.",
        },
        //인증
        otp: {
          title: "Validation Code",
          sendBtn: "Send Code",
          confirmBtn: "Verify",
          enterMsg: "Enter the validation code sent to your email",
          sendTokenMsg:
            "A verification code has been sent to your email address.",
          successMsg: "Verification successful.",
          infoMsg: "We have already sent an email. Please try again later.",
          mismatchMsg: "The validation code does not match.",
        },
      },

      // 비밀번호 재설정
      resetPassowrd: {
        title: "Forgot your password?",
        resetPasswordBtn: "Reset Password",
        goBackToLogin: "go back to login page",
        confirmAlert:
          "We’ve sent you an email containing a temporary password.\nPlease change your password from My Account after login.",
      },

      stepBar: {
        step1: "Sign Up/Login",
        step2: "Subscription Payment Info",
        step3: "Site Creation",
        step2Apply: "Application Info",
        step2Pay: "Payment Info",
        step2Coupon: "Coupon Info",
      },
    },
    // 요금제 type
    subscriptionType: {
      title: "Wrapsody eCo Cloud subscription plan",
      shortTitle: "{0} Cloud subscription plan",
      subTitle: "Please select your plan to start Wrapsody eCo Cloud.",
      shortsubTitle: "Please select your plan to start {0} Cloud.",
      showMore: "Show more features",
      hide: "Hide more features",
      dollar: "US",
      noticeMsg1: "Subscription Plan Notice",
      alreadyCreatedMsg: "You have already created a site.",
      limitFreeTrial:
        "Free trial is limited to new subscribers without free trial and cites creation history.",
      type: {
        free_1: "15-day Trial",
        free_2: "Free Trial",
        basic: "Basic",
        plus: "Plus",
        premium: "Premium",
      },
      fee: {
        free: "Free",
        basic: "$12",
        plus: "$25",
        premium: "Contact Us",
        won: "₩",
        dollar: "$",
      },
      monthlyPerPerson: "Monthly per person",
      minimumPerPerson: "Minimun of 10 Users per month",
      overThousandPerson:
        "Customized Wrapsody Cloud service for Fasoo partners.",
      annualPayment: "for annual payment",
      description: {
        free: "15-day free trial for\nanyone for secured file sharing and collaboration",
        drive:
          "Document management starter\nEasiest way to manage files and documents",
        basic:
          "Secured file sharing and collaboration\nOptimized for small businesses",
        wrapsodyBasic:
          "Secured file sharing and collaboration\nOptimized for small businesses",
        basicPlus:
          "Safely encrypting important files such as drawings, images,\nand videos beyond basic encryption file extensions",
        plus: "For projects requiring more storage\nspace and more external users",
        enterprise:
          "Advanced data protection and control\nOptimized for security-conscious teams",
        plusPlus:
          "Optimized for customers requiring strict\nsecurity with additional application support along with security features",
        premium: "Customized Wrapsody eCo Cloud\nservice for Fasoo partners.",
        wrapsodyPremium:
          "Providing customized services to each\ncustomer, along with all features of Enterprise Plus",
      },
      terms: {
        eco: {
          free_1: "Storage up to 100GB",
          free_2: "Maximum 10 users",
          free_3: "Each user can invite 5 external users",
          basic_1: "Shared storage\n: No. of users × 50GB",
          basic_2: "External invitations\n: No. of users × 10",
          basic_3: "Version management",
          basic_4: "Smart document sync",
          basic_5: "Data encryption",
          basic_6: "Mobile access",
          plus_1: "Shared storage\n: No. of users × 100GB",
          plus_2: "External invitations\n: No. of users × 20",
          plus_3: "Version management",
          plus_4: "Smart document sync",
          plus_5: "Data encryption",
          plus_6: "Mobile access",
          plus_7: "Support additional applications",
          premium_1: "Customizable storage ",
          premium_2: "User-defined number of users and invitations",
          premium_3: "All functions of paid plan are provided.",
          premium_4: "Compatible with Office 365",
          premium_5: "Compatible with FASOO products",
          premium_6: "Admin and user training ",
          premium_7: "Support additional applications",
        },
        wrapsody: {
          free_1: "Total storage 50 GB",
          free_2:
            "15-day free trial for anyone for secured file sharing and collaboration",
          drive_1: "50GB per user are provided",
          drive_2: "View/Revise encrypted document",
          drive_3: "File event tracing",
          drive_4: "Smart Sync",
          drive_5: "",
          drive_6: "",
          basic_1: "50GB per user are provided",
          basic_2: "All functions of Basic plan are provided",
          basic_3: "Detailed access management",
          basic_4: "Smart Cleaner",
          basic_5: "",
          basic_6: "",
          basicPlus_1: "50GB per user are provided",
          basicPlus_2: "All functions of Standard plan are provided",
          basicPlus_3: "Support additional applications",
          basicPlus_4: " ",
          basicPlus_5: " ",
          basicPlus_6: " ",
          plus_1: "100GB per user are provided",
          plus_2: "All functions of Standard plan\nare provided ",
          plus_3: "Local save management",
          plus_4: "Prevent unauthorized file leakage",
          plus_5: " ",
          plus_6: " ",
          plusPlus_1: "100GB per user are provided",
          plusPlus_2: "All functions of Enterprise plan\nare provided ",
          plusPlus_3: "Support additional applications",
          plusPlus_4: " ",
          plusPlus_5: " ",
          plusPlus_6: " ",
          premium_1: "Real-time document encryption regardless of location",
          premium_2: "Document-specific access control and usage restrictions",
          premium_3: "Backup and restore options against ransomware threats",
          premium_4: "Organizational and file-based chat service",
          premium_5: "Admin training",
          premium_6: "Customized Wrapsody Cloud service for Fasoo partners.",
        },
        dspm: {
          premium_1: "Data lineage for complete visibility of data flows",
          premium_2: "Fast and accurate storage security assessment",
          premium_3: "Robust compliance management processes",
        },
        dsp: {
          premium_1: "Integrated data security",
          premium_2: "Provisional policy management included",
          premium_3: "Customizable coverage options",
        },
        fireside: {
          premium_1: "Message and file data encryption",
          premium_2: "Automatic deletion of sensitive information",
          premium_3: "AI integration and chatbot utilization",
        },
      },
      startSubscriptionBtn: {
        eco: {
          free: "Start Free Trial",
          basic: "Start Basic",
          plus: "Start Plus",
          premium: "Start Premium",
        },
        wrapsody: {
          free: "Start Free Trial",
          drive: "Start Basic",
          basic: "Start Standard",
          basicPlus: "Start Standard Plus",
          plus: "Start Enterprise",
          plusPlus: "Start Enterprise Plus",
          premium: "Start Premium",
        },
      },
      keyFeatures: {
        wrapsody: {
          feature: "Key Features",
          feature_0: "Storage",
          feature_1: "Granular access control",
          feature_2: "Shareable total storage space",
          feature_3: "View/Revise encrypted document",
          // feature_4: "User management",
          feature_4: "Mobile App",
          // feature_5: "Mobile Security control",
          feature_5: "Web Office",
          feature_6: "File Content Search",
          // feature_7: "Activity tracing of entire users",
          feature_7: "Smart File Sync",
          feature_8: "Encryption policy compliance",
          // feature_9: "Smart sync",
          feature_9: "Complete document trace and management",
          feature_10: "File event tracing",
          // feature_11: "Web preview",
          feature_11: "Smart Cleaner",
          feature_12: "Integrated management console",
          // feature_13: "Domain statistics",
          feature_13: "Document Security Enhancement Package",
          // feature_14: "Editing on the web",
          feature_14: "Editing on the web",
          // feature_15: "Compatible with Fasoo products (SSO)",
          feature_15: "Local Save Management",
          // feature_16: "Customized branding",
          feature_16: "Screen Watermark",
          // feature_17: "Delegate manager role",
          feature_17: "Enterprise Secure Messenger",
          // feature_18: "File content search",
          feature_18: "Hybrid Cloud Storage",
          // feature_19: "Smart cleaner",
          feature_19: "API Support for Internal System Integration",
          // feature_20: "Wrapsody Drive",
          feature_20: "Organizational Chart Integration",
          // feature_21: "Document Security Enhancement Package",
          feature_21: "Admin Training",
          // feature_22: "Local Save Management",
          // feature_23: "File-based chat service",
          // feature_24: "Integration with exclusive storage",
          // feature_25: "Distributed storage management",
          // feature_26: "API for integration with\ncustomer’s in-house system",
          // feature_27: "Screen Watermark",
          // feature_28: "Admin training",
          // feature_29: "Single Sign-On (SSO) integration",
          // feature_30: "Support additional applications",
        },
        eco: {
          feature: "Key Features",
          feature_0: "Minimum Users",
          feature_0_1: "10 Users",
          feature_1: "Storage",
          feature_2: "External Users",
          feature_3: "Granular access control",
          feature_4: "Shareable total storage space",
          feature_5: "View/Revise encrypted document",
          feature_6: "User management",
          feature_7: "Mobile security control",
          feature_8: "Complete document trace and management",
          feature_9: "Activity tracing of entire users",
          feature_10: "Encryption policy compliance",
          feature_11: "Smart sync",
          feature_12: "File event tracing",
          feature_13: "Web preview",
          feature_14: "Integrated management console",
          feature_15: "Domain statistics",
          // feature_16: "Support additional application",
          feature_16: "Editing on the web",
          feature_17: "Compatible with Fasoo products (SSO)",
          feature_18: "Customized branding",
          feature_19: "Delegate manager role",
          feature_20: "Support additional applications",
          bottom: "Support additional applications",
        },
        terms: {
          free_1: "Total 50GB",
          drive_1: "50GB per user",
          basic_1: "50GB per user",
          basic_2: "Each user can invite 10 external users",
          basicPlus_1: "50GB per user",
          plus_1: "100GB per user",
          plus_2: "Each user can invite 20 external users",
          plusPlus_1: "100GB per user",
          premium_1: "Customizable",
          premium_2: "User-defined number of users and invitations",
        },
      },
    },
    siteType: {
      tab1: "Terms of Service",
      tab2: "Privacy Policy",
      tab3: "Terms of Service for Paid Plans",
      subscribeBtn: "Subscribe",
      send: "Send",
      agreement1: "I agree to the",
      agreement2: " Terms of Service",
      agreement3: " and the",
      agreement4: " Privacy Policy",
      agreement5: ", and the",
      agreement6: " Terms of Service for Paid Plans",
      agreement7: ".",
      agreement:
        "Please agree to the Terms of Service, the Terms of Service for Paid Plans, and the Privacy Policy.",
      info: "*All data will be deleted 30 days after your plan expires.",
      alert: {
        Msg1: "Please confirm expiration date of promotion.",
        Msg2: "Please confirm number of internal users.",
        Msg3: "Please confirm number of external invitations per user.",
        Msg4: "Please confirm storage space per user.",
      },

      subscriptionType: {
        eco: {
          subscriptionType_free: "15-day trial",
          subscriptionType_basic: "Basic",
          subscriptionType_plus: "Plus",
          subscriptionType_premium: "Premium",
        },
        wrapsody: {
          subscriptionType_free: "15-day trial",
          subscriptionType_drive: "Basic",
          subscriptionType_basic: "Standard",
          subscriptionType_basicPlus: "Standard Plus",
          subscriptionType_plus: "Enterprise",
          subscriptionType_plusPlus: "Enterprise Plus",
          subscriptionType_premium: "Premium",
        },
        dspm: {
          subscriptionType_premium: "Premium",
        },
        dsp: {
          subscriptionType_premium: "Premium",
        },
        fireside: {
          subscriptionType_premium: "Premium",
        },
      },

      paymentSuccess: "Your payment has been successfully processed.",
      referralIdOptional: "Referral ID (optional)",
      referralId: "Referral ID",
      manager: "Manager",
      managerId: "manager ID",
      changeManager: "Change Manager",
      enterIdEmail: "Enter a user ID or email address.",
      referral_title: "Referral ID (optional) ",
      referral_id: "Enter ID or email address",
      free: {
        title: "{0} Cloud Free Trial",
        subTitle:
          "Please fill out below and click Start Free Trial. We will get back to your email soon.",
        detail: {
          title: "User Information",
          username: "User Name",
          enterUserName: "User name",
          phoneNumber: "Phone Number",
          enterPhoneNumber: "Phone number",
          company: "Company",
          enterCompany: "Company name",
          purpose: "Purpose",
          info: "* All data will be deleted when your trial expires.",
          alertMsg1: "User name must not exceed 50 characters.",
          alertMsg2: "Contact info must not exceed 30 characters.",
          alertMsg3: "Company must not exceed 100 characters.",
          alertMsg4: "Purpose must not exceed 500 characters.",
          alertMsg5: "Please enter the phone number.",
        },
        orderSpecification: {
          title: "Free trial includes",
          planType: "Subscription plan",
          showMore: "Show all features",
          hide: "Hide",
          startBtn: "Start Free Trial",
        },
      },
      title: "{0} Cloud {1}",
      subTitle: "Please fill out below to subscribe {0} plan.",
      drive: {
        title: "Wrapsody eCo Cloud Basic",
        subTitle: "Please fill out below to subscribe Basic plan.",
        detail: {
          plan: {
            title: "Plan Details",
            userNum: "Number of Users",
            userNumCheckMsg: "Number of users must be between {0} and {1}.",
            paymentCycle: "Payment cycle",
            payType_month: "Monthly",
            price_condition_per_user: "",
            price_condition_monthly: "/month for each user",
            annual_sum: "Annual total",
            payType_annual: "Annual",
            price_condition_annual: "/year for each user",
            discount: "Save 20%",
          },
          payment: {
            title: "Payment Details",
            info: "Please make an inquiry to pay by other means.",
            info_1: "Please make an ",
            info_2: "inquiry ",
            info_3: "to pay by other means.",
            cardNum: "Card number",
            expirationDate: "Expiration date",
            enterExpirationDate: "mm/yy",
            csc: "CSC",
            country: "Country",
            zipcode: "Zip code",
          },
        },
        orderSpecification: {
          title: "Your Order",
          planType: "Subscription plan",
          showMore: "Show all features",
          hide: "Hide",
          subscription: "Subscription",
          price: "Price",
          subscribedUsers: "{0} users",
          year: "/year",
          month: "/month",
          annulDiscount: "Annual discount",
          total: "Total",
        },
      },
      basic: {
        title: "Wrapsody eCo Cloud Basic",
        subTitle: "Please fill out below to subscribe Basic plan.",
        detail: {
          plan: {
            title: "Plan Details",
            userNum: "Number of Users",
            userNumCheckMsg: "Number of users must be between {0} and {1}.",
            paymentCycle: "Payment cycle",
            payType_month: "Monthly",
            price_condition_per_user: "",
            price_condition_monthly: "/month for each user",
            annual_sum: "Annual total",
            payType_annual: "Annual",
            price_condition_annual: "/year for each user",
            discount: "Save 20%",
          },
          payment: {
            title: "Payment Details",
            info: "Please make an inquiry to pay by other means.",
            info_1: "Please make an ",
            info_2: "inquiry ",
            info_3: "to pay by other means.",
            cardNum: "Card number",
            expirationDate: "Expiration date",
            enterExpirationDate: "mm/yy",
            csc: "CSC",
            country: "Country",
            zipcode: "Zip code",
          },
        },
        orderSpecification: {
          title: "Your Order",
          planType: "Subscription plan",
          showMore: "Show all features",
          hide: "Hide",
          subscription: "Subscription",
          price: "Price",
          subscribedUsers: "{0} users",
          year: "/year",
          month: "/month",
          annulDiscount: "Annual discount",
          total: "Total",
        },
      },
      basicPlus: {
        title: "Wrapsody Cloud Standard Plus",
        subTitle: "Please fill out below to subscribe Standard Plus plan.",
        detail: {
          plan: {
            title: "Plan Details",
            userNum: "Number of Users",
            userNumCheckMsg: "Number of users must be between {0} and {1}.",
            paymentCycle: "Payment cycle",
            payType_month: "Monthly",
            price_condition_per_user: "",
            price_condition_monthly: "/month for each user",
            annual_sum: "Annual total",
            payType_annual: "Annual",
            price_condition_annual: "/year for each user",
            discount: "Save 20%",
          },
          payment: {
            title: "Payment Details",
            info_1: "Please make an ",
            info_2: "inquiry ",
            info_3: "to pay by other means.",
            cardNum: "Card number",
            expirationDate: "Expiration date",
            enterExpirationDate: "mm/yy",
            csc: "CSC",
            country: "Country",
            zipcode: "Zip code",
          },
        },
        orderSpecification: {
          title: "Your Order",
          planType: "Subscription plan",
          showMore: "Show all features",
          hide: "Hide",
          subscription: "Subscription",
          price: "Price",
          subscribedUsers: "{0} users",
          year: "/year",
          month: "/month",
          annulDiscount: "Annual discount",
          total: "Total",
        },
      },
      plus: {
        title: "Wrapsody eCo Cloud Plus",
        subTitle: "Please fill out below to subscribe Plus plan.",
        detail: {
          plan: {
            title: "Plan Details",
            userNum: "Number of Users",
            paymentCycle: "Payment cycle",
            payType_month: "Monthly",
            price_condition_per_user: "",
            price_condition_monthly: "/month for each user",
            annual_sum: "Annual total",
            payType_annual: "Annualy",
            price_condition_annual: "/year for each user",
            discount: "Save 20%",
          },
          payment: {
            title: "Payment Details",
            info: "Please make an inquiry to pay by other means",
            cardNum: "Card number",
            expirationDate: "Expiration date",
            enterExpirationDate: "mm/yy",
            csc: "CSC",
            country: "Country",
            zipcode: "Zip code",
          },
        },

        orderSpecification: {
          title: "Your Order",
          planType: "Subscription plan",
          showMore: "Show all features",
          hide: "Hide",
          subscription: "Subscription",
          price: "Price",
          subscribedUsers: "{0} users",
          year: "/year",
          month: "/month",
          annulDiscount: "Annual discount",
          total: "Total",
        },
      },
      plusPlus: {
        title: "Wrapsody Cloud Enterprise Plus",
        subTitle: "Please fill out below to subscribe Enterprise Plus plan.",
        detail: {
          plan: {
            title: "Plan Details",
            userNum: "Number of Users",
            paymentCycle: "Payment cycle",
            payType_month: "Monthly",
            price_condition_per_user: "",
            price_condition_monthly: "/month for each user",
            annual_sum: "Annual total",
            payType_annual: "Annualy",
            price_condition_annual: "/year for each user",
            discount: "Save 20%",
          },
          payment: {
            title: "Payment Details",
            info: "",
            info_1: "Please make ",
            info_2: "inquiry ",
            info_3: "an to pay by other means.",
            cardNum: "Card number",
            expirationDate: "Expiration date",
            enterExpirationDate: "mm/yy",
            csc: "CSC",
            country: "Country",
            zipcode: "Zip code",
          },
        },

        orderSpecification: {
          title: "Your Order",
          planType: "Subscription plan",
          showMore: "Show all features",
          hide: "Hide",
          subscription: "Subscription",
          price: "Price",
          subscribedUsers: "{0} users",
          year: "/year",
          month: "/month",
          annulDiscount: "Annual discount",
          total: "Total",
        },
      },
      premium: {
        title: "{0} Cloud Premium",
        subTitle: "Please fill out below to subscribe Premium plan",
        askTitle: "Request for Customized Plan Consultation",
        askSubTitle:
          "Please enter the desired subscription plan details and click Send.",
        continueTitle: "Request for Customized Plan Consultation",
        continueSubTitle:
          "Please enter the desired subscription plan details and click Send.",
        detail: {
          plan: {
            title: "Plan Details",
            promotionCode: "Promotion Code",
            enterPromotionCode: "Enter your promotion code.",
            registerBtn: "Register",
            validPromotionCode: "Valid promotion code.",
            invalidPromotionCode: "Invalid promotion code.",
            expirationDate: "Validity",
            availablePeriods: "Expiration date",
            days: "{0} day(s)",
            until: "",
            userNum: "Number of Users",
            person: "{0} user(s)",
            haveCode: "Do you have a promotion code?",
            dontHaveCode: "You don't have a promotion code?",
            contactInfo: "Contact Info (Phone or Email)",
            comment: "Comment",
            period: "Subscription Period",
            startDate: "Start date",
            endDate: "End date",
            userStorage: "Storage space per user (GB)",
            userStorageCheckMsg:
              "Storage space per user must be between {0}GB and {1}GB.",
            userExtenalInvite: "External invitations",
            userExtenalInviteCheckMsg:
              "Number of external invitations per user must be between {0} and {1}.",
            user: "Number of Users",
            alert: {
              Msg1: `You've already requested.`,
            },

            package: {
              dsp_1: "PC Document Security",
              dsp_2: "Print Security",
              dsp_3: "Screen Security",
              dsp_4: "Content Backup & Recovery",
              dsp_5: "Document Security+ Package",
              dsp_6: "Document Security & DR Package",
              dsp_7: "Privacy Package",
              dsp_8: "All-In-One Data Security Package",
            },
          },
          partnerInfo: {
            title: "Partner Info",
            emailAddress: "Email address of person in charge",
            purpose: "Purpose",
            enterPurpose:
              "Let us know your intended use so we can provide more accurate support. We’ll get back to you shortly.",
          },
        },

        orderSpecification: {
          title: "Your Order",
          planType: "Subscription plan",
          showMore: "Show all features",
          hide: "Hide",
        },
      },

      //요금제 문의
      inquiry: {
        customizedPayment: "Request for Customized Plan Consulation",
        customizedPayment_desc:
          "Please enter the desired subscription plan details and click Send.",
        changePayment: "Request for Customized Plan Consulation",
        changePayment_desc:
          "Please enter the desired subscription plan details and click Send.",
        inquiryBtn: "Send",
      },

      complete: {
        title: "Your request has been successfully submitted.",
        subTitle: "We will get back to your email as soon as possible.",
        goToMainBtn: "Next Step",
      },

      promotionApply: {
        title: "Your premium plan inquiry has been received.",
        subTitle: "We will get back to you via email as soon as possible.",
        goToMainBtn: "Subscribe Premium",
        goToConsoleBtn: "Go to Site Management",
      },

      promotionApplied: {
        title: "Your promotion code has been applied.",
        subTitle: "Enjoy the Wrapsody eCo Cloud experience now.",
        goToMainBtn: "Create Site",
      },
    },
    siteManagement: {
      title: "Site Management",
      subTitle: "Create a site for your company.",
      info: "You can add a site by clicking the Create Site button above.",
      createBtn: "Create Site",
      useWrapsody: "Enjoy the Wrapsody experience now.",
      nextStep: "Next Step",
      upgradeBtn: "Upgrade",
      expirationInfo: {
        eco: "Your free trial expires in {0} days. Please add a payment method to continue to use Wrapsody eCo Cloude service.",
        wrapsody:
          "Your free trial expires in {0} days. Please add a payment method to continue to use Wrapsody Cloude service.",
      },
      info1: {
        Msg1: "Your free trial expires on {0}. Switch to a paid plan to experience stable service.",
        Msg2: "You are subscribed to the [{0}] plan. Your next payment date is {1}.",
        Msg3: "Payment failed for [{0}]. Your subscription expires on {1}.",
        Msg4: "Your subscription for [{0}] expires on {1}. Please resubscribe to continue running the site",
        // Msg5: "[{0}] site will be deleted on {1} 30 days after the subscription expiration date. To maintain the site, please proceed with the payment.",
        Msg5: "[{0}] will be deleted on {1}, 30 days after its expiration date. Contact the {2} representative to retain the site.",
      },
      notice: {
        cancleSubscription1:
          "Do you really want to terminate recurring payments?",
        cancleSubscription2:
          "You will retain access until {0} the end of your subscription period. You can resubscribe at any time before the date of termination.",
        resubscribe1: "Would you like to resubscribe?",
        resubscribe2:
          "Your subscription will be restarted, and your subscription fee will be charged on {0}",
        comfirmPay:
          "Payment will be processed using the existing payment method. Cancellations and refunds are not possible once payment is made for reasons such as issuance of licenses and storage capacity expansion. Would you like to proceed with payment?",
      },
      free: {
        beforeApplication: {
          title: "Your request has been successfully submitted.",
          subTitle: "We will get back to your email as soon as possible.",
          goToMainBtn: "Next Step",
          upgradeInfoMsg:
            "You can use the service immediately after switching to a paid service. Do you want to upgrade to a paid plan? ",
          upgradeBtn: "Upgrade to a paid plan",
        },
        afterApplication: {
          title: "Your request has been approved.",
          subTitle: "Please create a site. ",
          goToMainBtn: "Create Site",
        },
      },
      premium: {
        beforeApplication: {
          title: "Your premium plan inquiry has been received.",
          subTitle: "We will get back to you via email as soon as possible.",
          goToMainBtn: "Back to Main Page",
        },
        afterApplication: {
          title: "Your promotion code has been applied.",
          subTitle: "Enjoy the Wrapsody experience now.",
          goToMainBtn: "Next Step",
        },
      },
      createSiteModal: {
        title: "Create Site",
        siteName: "Site Name",
        siteUrl: "Site URL",
        siteId: "Site ID",
        siteNameCheckMsg: "Site name must not exceed {0} characters.",
        siteUrlCheckMsg: "Site URL must not exceed {0} characters.",
        siteIdCheckMsg:
          "Site ID can contain only lowercase English letters and numbers.",
        aleadyExistUser:
          "This account is already registered to a Wrapsody or Fireside site, so it cannot create a new one. Please leave the existing site or delete your account and try again.",
        tooltip: {
          siteId: "The site ID cannot be changed after the initial setup.",
          siteUrl: "The URL cannot be changed after the initial setup.",
        },
        placeholder: {
          siteName: "Enter a site name.",
          siteId: "Please enter an ID for site creation.",
        },
        alert: {
          validAddress: "Valid address",
          validId: "Valid ID",
          invalidAddress: "Invalid address",
          invalidId:
            "Site ID can contain only lowercase English letters and numbers.",
          isDuplicate: "Already exists.",
        },
        serverLocation: {
          fieldname: "Server location",
          option_1: "Seoul, Republic of Korea",
          option_2: "Northern Virginia",
        },
        validAddress: "Valid address",
        suffix: {
          ociEco: "cloud.wrapsodyeco.com/",
          ociWrapsody: "cloud.wrapsody.com/",
          eco: ".wrapsodyeco.com",
          wrapsody: ".wrapsody.com",
        },
      },
      createSite: {
        createStatus: "Creating a site",
        createStatusStart:
          "Please wait until the site creation is completed.\nIt may take about 10 minutes to start the service after creating a site. Admin account ID and a temporary password will be sent to your email upon completion.",
        createStatusComplete: "A site has been successfully created.",
        goAdminPageBtn: "Admin Page",
        goUserPageBtn: "User Page",
        delete: "delete Site",
        // win64: 'Window Client x64',
        // win32: 'Window Client x86',
        // mac: 'Mac Client',
        // guide: 'Guide Download',
        detail: {
          title: "Details",
          siteName: "Site name",
          goToEdit: "Edit",
          siteAddress: "Site address",
          currentUser: "Current user",
          maxUser: "Max user",
          createDate: "Created",
          lastAccessDate: "Last accessed",
          serverLocation: "Server location",
          //running: 'Running',
          storage: {
            fieldname: "Storage",
            byteUnit: "GB",
            usage: "used out of",
            usageMsg: "{1} used out of {0}",
            info: "Functions such as revising and creating documents do not work when capacity is insufficient.\nPlease Upgrade your plan to purchase additional licenses and free up capacity.",
            info_fireside:
              "When your storage is full, you won’t be able to send files in the chat.\nPlease upgrade your license to secure additional storage capacity.",
            unlimit: "Unlimited",
          },
        },
        // createStepMsg: 'A site has been successfully created.',
        createStepMsg_1: "Completed",
        createStepMsg_2: "Allocating storage space…",
        createStepMsg_3: "Initializing the site…",
        createStepMsg_4: "Getting the required information to open a site…",
        createStepMsg_5: "Applying information set by user…",
        createStepMsg_6:
          "Generating an encryption key for document encryption…",
        createStepMsg_7: "Starting the site…",
        createStepMsg_8: "Waiting for the distribution of the URL you set…",
        siteCreatedTitle: "Site Created",
        siteCreatedBody: "A site has been successfully created.",
        siteCreatedDesc: {
          eco: "Go to the admin page and start your Wrapsody eCo experience.",
          wrapsody: "Go to the user page and start your Wrapsody experience.",
        },
      },
      popup: {
        change: {
          siteName: "Change Site Name",
          enterSiteName: "Enter a new site name.",
          siteAddress: "Change Site Address",
          newName: "New Name",
        },
        delete: {
          title: "Delete Site",
          info: "Do you really want to delete the site?",
          subInfo:
            "When deleting a site, all data is completely deleted and cannot be restored.",
          subInfo1:
            "All data will be retained for 30 days after deletion.\nAfter 30 days, it is completly deleted and cannot be restored.",
        },
        guide: {
          title: "Guide Download",
          download:
            "https://www.wrapsodyeco.com/pdf/en/Wrapsody_eCo_v2.4_Admin_Guide.pdf",
          downloadAdmin: "Download Admin Guide",
          moveAdmin: "Move to Admin Page",
          msg1: "Do you want to know how to use Wrapsody eCo?",
          msg2: "We recommend you go through the admin guide first.",
          close30Days: "Do not show for 30 days",
        },
      },

      paymentHistory: {
        title: "Payment History",
        selectSiteBtn: "Select a site",
        paymentManagement: {
          title: "Plan Management",
          resubscription: "Undo Cancellation",
          resumeSubscription: "Resume Subscription",
          resumeSubscriptionNewCard: "Resume Subscription with New Card",
          cancelSubscription: "Terminate Recurring Payments",
          payment: "Plan",
          user: "Number of Users",
          paymentCycle: "Payment cycle",
          maxStorage: "Maximum storage(GB)",
          startDate: "Site opening",
          endDate: "Site expiration",
          unlimited: "-",
        },
        payment: {
          title: "Payment Method",
          add: "Add Payment method",
          change: "Change payment method",
          cash: "Cash",
          card: "Card",
          coupon: "Coupon",
        },
        history: {
          title: "Payment History",
          paymentSystem: "Plan",
          date: "Payment date",
          license: "No.of Users",
          cardInformation: "Card details",
          fee: "Fee",
          progressState: "Status",
          bill: "View Bill",
          disagree: "Auto refunded: recurring payments not accepted",
          subscriptionInfo: "Subscription Info",
          period: "Subscription Period",
          failState: "Failed",
          failState1: "Failed (1 time)",
          failState2: "Failed (2 times)",
          failState3: "Failed (3 times)",
          successState: "Succeeded",
        },
        popUp: {
          changeSiteType: {
            title: "Change Plan",
            basicToPlus: {
              eco: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of Users : {0} ",
                    Msg3: "Amount of immediate payment : {0}{1}",
                    Msg3_1:
                      "(fee difference (Plus plan- Basic plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Plus plan starts from {0}) {1}{2}",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of Users : {0}",
                    Msg3: "Amount of immediate payment : {0}{1}",
                    Msg3_1:
                      "(fee difference (Plus plan- Basic plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Plus plan starts from {0}) {1}{2}",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
              wrapsody: {
                USD: {
                  info: {
                    annual: {
                      Msg1: "Payment cycle : Annually",
                      Msg2: "Number of Users : {0} ",
                      Msg3: "Amount of immediate payment {0} USD",
                      Msg3_1:
                        "(fee difference (Enterprise plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                      Msg4: "Subscription fee from next year on (Enterprise plan starts from {0}) {1} USD",
                      Msg5: "* VAT excluded (10%)",
                    },
                    monthly: {
                      Msg1: "Payment cycle : Monthly",
                      Msg2: "Number of Users : {0}",
                      Msg3: "Amount of immediate payment {0} USD",
                      Msg3_1:
                        "(fee difference (Enterprise plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                      Msg4: "Subscription fee from next month on (Enterprise plan starts from {0}) {1} USD",
                      Msg5: "* VAT excluded (10%)",
                    },
                  },
                },
                KRW: {
                  info: {
                    annual: {
                      Msg1: "Payment cycle : Annually",
                      Msg2: "Number of Users : {0} ",
                      Msg3: "Amount of immediate payment ￦ {0}",
                      Msg3_1:
                        "(fee difference (Enterprise plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                      Msg4: "Subscription fee from next year on (Enterprise plan starts from {0}) ￦ {1}",
                      Msg5: "* VAT excluded (10%)",
                    },
                    monthly: {
                      Msg1: "Payment cycle : Monthly",
                      Msg2: "Number of Users : {0}",
                      Msg3: "Amount of immediate payment ￦ {0}",
                      Msg3_1:
                        "(fee difference (Enterprise plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                      Msg4: "Subscription fee from next month on (Enterprise plan starts from {0}) ￦ {1}",
                      Msg5: "* VAT excluded (10%)",
                    },
                  },
                },
              },
            },
            basicTobasicPlus: {
              USD: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of Users : {0} ",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(fee difference (Standard Plus plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Plus plan starts from {0}) {1} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of Users : {0}",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(fee difference (Standard Plus plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Plus plan starts from {0}) {1} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
              KRW: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of Users : {0} ",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(fee difference (Standard Plus plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Standard Plus plan starts from {0}) ￦ {1}",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of Users : {0}",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(fee difference (Standard Plus plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Standard Plus plan starts from {0}) ￦ {1}",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
            },
            basicToplusPlus: {
              USD: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of Users : {0} ",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Enterprise plan starts from {0}) {1} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of Users : {0}",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Enterprise plan starts from {0}) {1} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
              KRW: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of Users : {0} ",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Enterprise Plus plan starts from {0}) ￦ {1}",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of Users : {0}",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Standard plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Enterprise Plus plan starts from {0}) ￦ {1}",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
            },
            basicPlusToplusPlus: {
              USD: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of Users : {0} ",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Standard Plus plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Enterprise plan starts from {0}) {1} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of Users : {0}",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Standard Plus plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Enterprise plan starts from {0}) {1} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
              KRW: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of Users : {0} ",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Standard Plus plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Enterprise Plus plan starts from {0}) ￦ {1}",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of users : {0}",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Standard Plus plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Enterprise Plus plan starts from {0}) ￦ {1}",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
            },
            plusToplusPlus: {
              USD: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of users : {0} ",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Enterprise plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Enterprise Plus plan starts from {0}) {1} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of users : {0}",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Enterprise plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Enterprise Plus plan starts from {0}) {1} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
              KRW: {
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of Users : {0} ",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Enterprise plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (Enterprise Plus plan starts from {0}) ￦ {1}",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of Users : {0}",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(fee difference (Enterprise Plus plan- Enterprise plan) × number of users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (Enterprise Plus plan starts from {0}) ￦ {1}",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
            },
            toPremium: {
              info: {
                Msg1: "Premium subscription fees will be determined based on the storage and number of users you set. We will guide your payment process accordingly.",
              },
            },
          },
          changeNumberOfUsers: {
            title: "Edit User Counts",
            beforeChange: "AS IS",
            afterChange: "TO BE",
            changeNumberUserMsg:
              "Number of Users to add must be between 0 and {0}",
            Msg1: "Please contact us via ",
            Msg2: "Q&A",
            Msg3: " to reduce the number of users.",
            Msg4: "I agree to the above changes and payment amount.",
            eco: {
              info_1: "The existing annual payment amount is US",
              info_2: "(for {0} users.)",
              info_3: "The existing monthly payment amount is US",
              info_4: "(for {0} users.)",
              info_5: "The changed annual payment amount is US",
              info_6: "(for {0} users.)",
              info_7: "The changed monthly payment amount is US",
              info_8: "(for {0} users.)",
              info: {
                annual: {
                  Msg1: "Payment cycle : Annually",
                  Msg2: "Number of users : {0} ",
                  Msg3: "Amount of immediate payment {0}{1}",
                  Msg3_1:
                    "(annual subscription fee × number of added users) / 365 × remaining days until next payment date",
                  Msg4: "Subscription fee from next year on (for {1} users from {0}) : {2}{3}",
                  Msg5: "* VAT excluded (10%)",
                },
                monthly: {
                  Msg1: "Payment cycle : Monthly",
                  Msg2: "Number of users : {0}",
                  Msg3: "Amount of immediate payment {0}{1}",
                  Msg3_1:
                    "(monthly subscription fee × number of added users × 12) / 365 × remaining days until next payment date",
                  Msg4: "Subscription fee from next month on (for {1} users from {0}) : {2}{3}",
                  Msg5: "* VAT excluded (10%)",
                },
              },
            },
            wrapsody: {
              USD: {
                info_1: "The existing annual payment amount is US",
                info_2: "(for {0} users.)",
                info_3: "The existing monthly payment amount is US",
                info_4: "(for {0} users.)",
                info_5: "The changed annual payment amount is US",
                info_6: "(for {0} users.)",
                info_7: "The changed monthly payment amount is US",
                info_8: "(for {0} users.)",
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of users : {0} ",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(annual subscription fee × number of added users) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (for {1} users from {0}) {2} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of users : {0}",
                    Msg3: "Amount of immediate payment {0} USD",
                    Msg3_1:
                      "(monthly subscription fee × number of added users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (for {1} users from {0}) {2} USD",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
              KRW: {
                info_1: "The existing annual payment amount is ￦",
                info_2: "(for {0} users.)",
                info_3: "The existing monthly payment amount is ￦",
                info_4: "(for {0} users.)",
                info_5: "The changed annual payment amount is ￦",
                info_6: "(for {0} users.)",
                info_7: "The changed monthly payment amount is ￦",
                info_8: "(for {0} users.)",
                info: {
                  annual: {
                    Msg1: "Payment cycle : Annually",
                    Msg2: "Number of users : {0} ",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(annual subscription fee × number of added users) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next year on (for {1} users from {0}) ￦ {2}",
                    Msg5: "* VAT excluded (10%)",
                  },
                  monthly: {
                    Msg1: "Payment cycle : Monthly",
                    Msg2: "Number of users : {0}",
                    Msg3: "Amount of immediate payment ￦ {0}",
                    Msg3_1:
                      "(monthly subscription fee × number of added users × 12) / 365 × remaining days until next payment date",
                    Msg4: "Subscription fee from next month on (for {1} users from {0}) ￦ {2}",
                    Msg5: "* VAT excluded (10%)",
                  },
                },
              },
            },
          },
          changePaymentCycle: {
            title: "Edit Payment Cycle",
            payType_month: "Monthly",
            payType_annual: "Annual",
            basis: "per user",
            annualPrice: "Annually {0}{1} for each user",
            info: {
              Msg1: "The changed payment cycle will be applied to your subscription fee starting {0}.",
              Msg2: "If you choose monthly payment, you will be charged {0}{1} every month.",
              Msg3: "If you choose annual payment, you will be charged {0}{1} every year.",
              Msg4: "*10% VAT not included",
            },
            // info_1: {
            //   Msg1:
            //     'The changed payment cycle will be applied to your subscription fee starting {0}.',
            //   Msg2:
            //     'If you choose monthly payment, you will be charged US${0} every month.',
            //   Msg3:
            //     'If you choose annual payment, you will be charged US${0} every year.',
            //   Msg4: '* VAT excluded (10%)'
            // },
            annualPrice_2: "Annually ￦{0} for each user",
            info_2: {
              Msg1: "The changed payment cycle will be applied to your subscription fee starting {0}.",
              Msg2: "If you choose monthly payment, you will be charged ￦{0} every month.",
              Msg3: "If you choose annual payment, you will be charged ￦{0} every year.",
              Msg4: "* VAT excluded (10%)",
            },
            month12: "12Month",
          },
        },
        bill: {
          inquiry: "inquiry",
          address: {
            address_1: "396 World Cup Buk-ro, Mapo-gu, Seoul 03925, Korea",
            detailedAddress: "",
            postalCode: "",
            vatId: "VAT ID: IE 9852817J",
            email: "helpdesk@fasoo.com",
          },
          detail: {
            title: "Bill",
            printBtn: "Print",
            billingTo: "Billing email",
            paymentMethod: "Payment method",
            paymentDate: "Payment date",
            id: "Account ID",
            payType: "Plan",
            user: "No. of users",
            expirationDate: "Plan duration",
            price: "Subtotal",
            total: "Total",
            info: "All amounts expressed in U.S. dollars.",
            includeVat: "VAT included (10%)",
          },
        },
      },
    },
    admin: {
      common: {
        logout: "Logout",
        alert: {
          invalidData: {
            request_freeTrial: "No free trial requests were found",
            request_coupon: "No coupon requests were found",
            search: "No results were found for your search.",
          },
          success: {
            added: "Successfully added.",
            edited: "Successfully edited.",
            deleted: "Successfully deleted.",
          },
          check: {
            enterPeriod: "Please enter the period.",
            enterLicense: "Please enter the number of licenses.",
            enterExternalLicense:
              "Please enter the number of external users per license.",
            enterStorage: "Please enter the storage per user.",
            enterValidity: "Please enter the coupon validity period.",
            enterCompany: "Please enter the company name.",
            enterPurpose: "Please enter the reason for issuing.",
          },
          login: {
            enterOtp: "Enter the validation code sent to your email.",
            enterUserId: "Please enter your ID.",
            enterPassword: "Please enter your password",
            error: "An error has occurred.",
          },
        },
      },
      login: {
        title: "Admin Login",
        id: "ID",
        password: "Password",
        otp: {
          sendBtn: "Send Validation Code",
          enterMsg: "Enter the code sent to your email.",
          goToLoginBtn: "Login",
          enterMsgAdmin: "Enter the validation code.",
          copy: "Copy",
        },
      },
      portal_dashboard: "Dashboard",
      portal_site: "Manage Service",
      portal_license: "Manange Licenses",
      portal_price: "Manage Payment",
      portal_coupon: "Manage Coupon",
      portal_trial: "Manage Free Trial",
      portal_notification: "Manage Notification",
      portal_user: "Manage Users",
      portal_admin_assignment: "Manage Admins",
      portal_fasoo_dto_stat: "Fasoo DTO Stat",
      portal_finance: "Manage Finance",
      portal_QnA: "Q/A Management",
      dashboard: {
        //대시보드
        total: "Total",
        new: "New (Yesterday)",
        register: "Registered",
        members: {
          title: "Members",
          cancel: "Cancelled",
          register: "Registered",
          total: "Members",
        },
        site: {
          title: "Site",
          delete: "Deleted",
          create: "Created",
          total: "Site",
        },
        subscription: {
          free: {
            type: "Free Trial",
            reject: "Rejected",
            approve: "Approved",
            register: "Registered",
          },
          premium: {
            type: "Premium",
            reject: "Rejected",
            approve: "Approved",
            register: "Registered",
            coupon: "Coupons Issued",
          },
        },
        storage: {
          title: "Storage Used (GB)",
          usage: "Storage Used (GB)",
        },
        budget: {
          title: "Budget",
          cancel: "Cancelled",
          pay: "Paid",
        },
      },
      siteMgnt: {
        filter: "Search Filters",
        userName: "User Name",
        userId: "User ID",
        subscriptionType: {
          title: "Subscription",
          all: "All",
          select: "Select",
          freeTrial: "Trial",
          premium: "Premium",
          paid: "Paid",
        },
        domain: "Domain Name",
        region: {
          title: "Server Location",
          america: "North America",
          asia: "Asia-Pacific",
        },
        subscriptionStatus: {
          title: "Status",
          all: "All",
          select: "Select",
          active: "Activated",
          unsubscribed: "Unsubscribed", //취소중
          mercyPeriod: "Mercy Period", //만료
          deactivated: "Deactivated",
          normal: "Running",
          suspended: "Stopped",
          ended: "Deactivated",
        },
        siteStatuses: {
          service: "Normal",
          ready: "Ready to deploy",
          fail: "Failed to deploy",
          restart: "Required to restart",
        },
        search: "Search",
        endDate: "",
        manager: "",
        no: "No.",
        url: "URL",
        serviceName: "Service Name",
        serverLocation: "Server Location",
        createDate: "Site Creation Date",
        subscriptionDate: "Subscription Date",
        subscriptionEndDate: "Subscription End Date",
        type: "Subscription Type",
        serviceStatus: "Status",
        siteStatus: "Site Status",
        user: "User Info.",
        payment: "Payment",
        detail: "Details",
        details: {
          manageService: "Manage Service",
          active: "Active",
          deactive: "Deactive",
          terminate: "Terminate",
          serviceName: "Service Name",
          subscriptionType: "Subscription Type",
          subscriptionDate: "Subscription Date",
          createDate: "Site Creation Date",
          expirationDate: "Site Expired Date",
          user: "User",
          storage: "Storage Used(GB) / Overall(GB)",
          license: "License (# of users)",
          externalLicense: "External License (# of users)",
          bucketName: "S3 Bucket Name",
          paymentHistory: {
            history: "Payment History",
            subscription: "Subscription",
            nextPayment: "Next Payment Date",
            paymentTerm: "Payment Term",
            license: "License (# of users)",
            storage: "Storage (GB)",
            code: "Subscription Code",
            price: "Price",
            paymentDate: "Payment Date",
            period: "Subscription Period",
            disagree: "Not accepted",
          },
          startInfo: `Write 'start' to start the service.`,
          stopInfo: `Write 'stop' to stop the service.`,
          terminateInfo: `Write 'terminate' to terminate the service.`,
        },
      },
      couponMgnt: {
        registrationInfo: {
          title: "Registration Information",
          no: "No.",
          code: "Code",
          license: "Licenses\n(# of Users)",
          externalLicense: "External\nLicenses\n(# of Users)",
          userStorage: "Storage Per User (GB)",
          company: "Company Name",
          purpose: "Registration Purpose",
          period: "Period",
          days: "day(s)",
          applicant: "Registered Email",
          registerDate: "Registered Date",
          approve: "Approve",
          issue: "Issue",
          noIssue: "Do not issue",
          reject: "Reject",
          rejectReason: "Reason For Reject",
        },
        issued: {
          title: "Coupons Issued",
          no: "No.",
          code: "Code",
          period: "Service Period",
          license: "License\n(# of users)",
          externalLicense: "External License\n(# of users)",
          storage: "Storage Per User (GB)",
          expirationDate: "Expiry Date",
          company: "Company",
          purpose: "Purpose",
          admin: "Issued Admin",
          date: "Issued Date",
          usageDate: "Usage Date",
          select: "Select",
          all: "All",
          used: "Used",
          unused: "Unused",
          request: "Coupon Request",
          reject: "Reject",
          rejectMsg: "Reject Coupon",
          addBtn: "Add Coupon",
          totalStorage: "Total Storage Space (GB)",
          subscriptionType: {
            freeTrial: "Trial",
            premium: "Premium",
            paid: "Paid",
          },
          siteStatus: "Subscription Type / Status /\nURL",
        },
      },
      cashMgnt: {
        list: "Cash Payment Request List",
        status: {
          wait: "Payment Request",
          apply: "Request of Deposit Confirm",
          approved: "Approval",
          done: "Site Creation Complete",
          reject: "Refused by Administrator",
          cancel: "Canceled by Requester",
        },
        issued: {
          depositor: `Depositor's name`,
          userAdmin: "Site Admin",
          price: "The total price",
          checkdate: "Deposit approval/rejection date",
          updateAdmin: "Status/updater",
        },
        acceptRequest: "Deposit confirmation",
        rejectRequest: "Deposit Refusal",
      },
      freeTrialMgnt: {
        pending: "Pending",
        approved: "Approved",
        name: "Name",
        account: "Email",
        phoneNumber: "Phone No.",
        company: "Company",
        purpose: "Purpose",
        reject: "Reject",
        approve: "Approve",
        requestDate: "Requested Date",
        approvedDate: "Approved / Rejected Date",
        approver: "Admin",
        rejectReason: "Reason for rejection",
        rejectMsg: "Free Trial Rejection",
        approvalStatus: {
          select: "Select",
          all: "All",
          approve: "Approve",
          reject: "Reject",
          deleted: "Delete",
        },
        subscriptionType: {
          freeTrial: "Trial",
          premium: "Premium",
          paid: "Paid",
        },
        siteStatus: "Subscription / Status /\nURL",
      },
      notificationMgnt: {
        current: "Current Notification",
        none: "None",
        list: "Notification List",
        no: "No.",
        email: "Email Alert",
        startDate: "Start Date",
        endDate: "End Date",
        notification_ko: "Notification(Korean)",
        notification_en: "Notification(English)",
        okBtn: "Okay",
      },
      userMgnt: {
        filter: "Search Filters",
        userName: "User Name",
        userId: "User ID",
        userType: "User Type",
        userEmail: "User Email",
        loginTime: "Last Login",
        entryTime: "Registration",
        email: "Email",
        search: "Search",
        export: "Export (Excel)",
        excelName: "eCo Cloud User List",
      },
      adminMgnt: {
        id: "Admin ID",
        permission: "Permission",
        entryDate: "Entry Date",
        updateDate: "Update Date",
        addBtn: "Add",
        modifyBtn: "Modify",
        deleteBtn: "Delete",
        modify: "Admin Permission Template",
        add: "Add Admin",
      },
      stat: {
        totalStat: "Total Stat",
        wgDocStat: "Workgroup / File Stat",
        workgroupList: "Workgroup List",
        documentsLog: "File Usage Log",
        wgStat: "Workgroup Stat",
        year: "Year",
        month: "Month",
        count: "Count",
        cnt: "",
        overCnt: "",
        include: "Include",
        exclude: "Exclude",
        workgropuCount: "Workgroup Count",
        workgroupCreateCount: "Workgroup Create Count",
        docCreateCount: "File Create Count",
        docUsageCount: "File Usage Count",
        memberCount: "Member Count",
        search: "Search",
        export: "Export (Excel)",
        workgroupName: "Workgroup name",
        manager: "Head of workgroup",
        managerDept: "Group name",
        createDate: "Date created",
        docCount: "Shared",
        status: "Status",
        internalUser: "Internal user",
        externalUser: "External user",
        storageUse: "Storage usage",
        dateTime: "Date used",
        fileName: "File name",
        version: "Version",
        userName: "User Name",
        userId: "User ID",
        deptName: "Group name",
        deptManagerName: "Head of group",
        type: "Usage type",
        view: "View",
        revise: "Revise",
        download: "Download",
        create: "Create",
        active: "Active",
        delete: "Delete",
        ip: "IP",
        agent: {
          name: "Platform",
          1: "Windows",
          2: "Mac",
          3: "Web",
          4: "Mobile",
          5: "Outlook",
          6: "FXM",
          0: "N/A",
        },
        updateInfo:
          "Data (Files shared, Storage usage) is updated at 1 am every day.",
        enterWorkgroupManager: "The name or ID of the head",
        enterUserNameOrID: "The name or ID of the user",
        retiree: "retiree",
        all: "All",
        chart: "Chart",
      },
      upc: {
        site: {
          applicationName: "Supported Application Name",
          applicationModal: "Supported Applications",
          detailBtn: "View Support Information",
          process: "Process Name",
          extension: "UPC Application Extensions",
          selectedApp: "Selected Applications:",
          applicationEditModal: "Modify Support Applications",
          enterDeposit: "Enter the name of the depositor.",
          upcSelectLimit: `For more application options, please contact us through the Wrapsody eCo Cloud website at <a target="_blank" href="https://www.wrapsodyeco.com/en/inquiry">wrapsodyeco.com/en/inquiry.</a>`,
        },
        countProcess: `{0} out of {1}`,
        modal: {
          title: "Representative Application",
          AddApp: "Add Representative Application",
          modifyApp: "Modify Representative Application",
          insertAppName: "Enter a representative application name.",
          upcExt: "UPC Application Extensions",
          insertProcessName: "Enter process name.",
          insertUpcExt:
            "Enter the UPC Application Extension in exe, ttt, sss, rrr.",
          alert: {
            add: "You can add it after entering all the information.",
            enterReuired: "Please fill in the required fields.",
            editSuccess: "Modify Completed",
            addSuccess: "Add Completed",
            deleteSuccess: "Delete Completed",
            confirmDelete: "Do you really want to delete the application?",
            onlyEngProcess:
              "Process names must consist of letters of the alphabet.",
            onlyEngExt:
              "Extension Name must consist of letters of the alphabet.",
          },
        },
      },
    },
    cashStatus: {
      pay_cash: "Pay Cash",
      complete: "Paid Complete",
      changeToCard: "Change to Card",
      requestNotic:
        "Your request has been successfully submitted to the administrator. We will check it as soon as possible and let you know by e-mail.",
      waitNotice:
        "We are currently waiting for your administrator to approve your cash request. If you want to cancel the payment request, please press the button.",
      //receiverPlaceholder: "입금자명을 정확하게 입력하시오",
      requestCash: "You have selected cash payment",
      chooseApp: "Choose Application",
      chooseSolution: "Choose Solution",
      chooseAppUntilThree: "Select three applications in maximum",
      chooseAppFour: "Select four applications in minimum",
      history: "Cash Payment History",
      requestCashCheck:
        "Please review the following information and press the [Request Payment Confirmation] button after you have made the deposit.",
      checkEmail:
        "We will check it as soon as possible and let you know by e-mail.",
      requestPayment: "Request Payment Confirmation",
      removePayment: "Cancellation of payment",
      removeSuccess: "Payment cancellation completed",
      removeModal: {
        removePaymentReason:
          "Please write the reason for the payment cancellation.",
        removePaymentMsg: "Reason for cancellation of payment",
      },
      pay: {
        bank: "Bank for deposit",
        account: "Account number",
        receiver: "Recipient",
        totalPrice: "Total Price",
        sender: "Name of depositor",
      },
      taxInvoice: {
        title: "Tax Invoice",
        owner: "Name of the representative",
        businessNumber: "Business registration number",
        requestDate: "Date of issue request",
        issuer: "Name of issuer",
        phoneNumber: "Telephone number of issuer",
        email: "Email address of issuer",
        placeHolder: {
          owner: "Enter the name of the representative.",
          businessNumber: "Enter the business registration number",
          requestDate: "Enter the date of issue request",
          issuer: "Enter the name of issuer",
          phoneNumber: "Enter the telephone number of issuer",
          email: "Enter the email address of issuer",
        },
      },
    },
  },

  ko: {
    common: {
      // message
      alert: {
        sessionExpired: "세션이 만료되었습니다.",
        serverError:
          "서비스에 문제가 발생하였습니다.\n잠시 후 다시 진행 하시기 바랍니다.\n(현상이 계속 되면 관리자에게 문의 바랍니다.)",
        // success: {
        //   findPasswordViaMail: {
        //     eco:
        //       '회원님의 이메일 계정으로 임시 비밀번호를 보냈습니다. 비밀번호는 로그인 후 내 계정 메뉴에서 변경할 수 있습니다.',
        //     wrapsody:
        //       '회원님의 이메일 계정으로 임시 비밀번호를 보냈습니다. 비밀번호는 로그인 후 계정설정 메뉴에서 변경할 수 있습니다.'
        //   }
        // },
        invalidData: "데이터가 존재하지 않습니다.",
        failPayment:
          "결제 주기가 변경되지 않았습니다. 고객센터로 문의해주세요.",
        enterRequired: "필수 입력란을 입력하십시오.",
        failedToSave: "변경 사항이 반영되지 않았습니다. 다시 시도해주세요.",
        noticePaypal: {
          eco: "Basic 및 Plus는 해외 전용 요금제입니다. 국내 사용자의 경우에는 Premium 요금제를 선택해주세요. 원하시는 조건으로 서비스를 이용할 수 있도록 Wrapsody eCo 담당자가 연락드리겠습니다.",
          wrapsody:
            "Basic 및 Plus는 해외 전용 요금제입니다. 국내 사용자의 경우에는 Premium 요금제를 선택해주세요. 원하시는 조건으로 서비스를 이용할 수 있도록 Wrapsody 담당자가 연락드리겠습니다.",
        },
        internetConnect:
          "인터넷 연결이 끊어졌습니다. 잠시 후 다시 시도하십시오.",
        limitExcess: "한도 초과로 카드 결제에 실패하였습니다.",
        changeCard: "결제 카드 변경이 완료 되었습니다.",
        cancelCard: "취소 요청이 완료되었습니다.",
        overPromotionCode: "프리미엄 코드 길이를 초과하였습니다.",
        sameManager: "담당자을 입력하지 않았거나, 동일한 담당자 입니다.",
      },
      tooltip: {
        clear: "입력값 지우기",
        showPassword: "비밀번호 표시",
        hidePassword: "비밀번호 숨김",
      },
      add: "추가",
      more: "더보기",
      backToHome: "처음으로",
      selected: "선택된 항목",
      items: "개",
      goBackBtn: "뒤로가기",
      cancelBtn: "취소",
      okBtn: "확인",
      deleteBtn: "삭제",
      modifyBtn: "수정",
      startBtn: "시작하기",
      addBtn: "등록",
      edit: "변경",
      vat: "* 부가세 10% 별도",
      card: "체크카드 및 신용카드",
      changeCard: "결제 카드 교체",
      korea: "대한민국",
      others: "대한민국 이외 국가",
      person: "사용자당",
      close: "닫기",
      product: "제품",
      application: "등록 애플리케이션",
      time: {
        sec: "초 전",
        min: "분 전",
        hour: "시간 전",
        day: "일 전",
      },
    },
    home: {
      tabs: {
        all: "전체",
        dataSecurity: "데이터 보안",
        documentManagement: "문서 중앙화",
        supplyChainSecurity: "공급망 보안・협업 플랫폼",
        privacyDetection: "개인정보 검출 관리",
        cloudSecurity: "클라우드 보안",
        phishingTraining: "악성메일 훈련",
        secureMessenger: "보안 메신저",
      },
      title: "클라우드 제품 선택",
      subTitle: {
        1: "악성메일 모의훈련 Mind-SAT부터 문서 중앙화 솔루션 Wrapsody, 다양한 문서보안 솔루션까지.",
        2: "우리 조직의 정보 보호, 파수 클라우드 서비스로 빠르고 합리적으로 완성하세요.",
      },
      consultingBtn: "도입 컨설팅 받기",
      productInfo: {
        title: "Product",
        btn: {
          learnMore: "자세히 알아보기",
          select: "선택하기",
          startNow: "지금 바로 시작하기",
          startFree: "무료로 시작하기",
        },
        features: "주요 기능",
        subTitle: {
          1: "악성메일 모의훈련 Mind-SAT부터 문서 중앙화 솔루션 Wrapsody, 다양한 문서보안 솔루션까지.",
          2: "우리 조직의 정보 보호, 파수 클라우드 서비스로 빠르고 합리적으로 완성하세요.",
        },
        dspWord: "이제 DRM도 클라우드에서 간편하게!",
        WRAPSODY: {
          name: "Wrapsody",
          word: "AI 시대 필수 문서중앙화 플랫폼",
          description:
            "AI 시대 필수 문서중앙화 플랫폼으로서 사내 모든 문서와 협업 히스토리를 자산화합니다.",
          moreInfo: {
            description: {
              1: "Wrapsody는 문서보안과 생산성 두 마리 토끼를 잡을 수 있는 AI 시대 필수 문서중앙화 플랫폼으로서 사내 모든 문서와 협업 히스토리를 자산화할 수 있게 도와줍니다.",
              2: "또, 모든 문서를 암호화하고 저장해  통합적으로 관리해 보안 걱정을 덜 수 있습니다.",
              3: "중복되고, 오래되고, 중요하지 않은 데이터를 관리해 AI 학습을 위한 데이터 파편화 문제를 해결해 보세요.",
            },
            subTitle:
              "AI 시대 필수 문서중앙화 플랫폼으로서 사내 모든 문서와 협업 히스토리를 자산화합니다.",
            features: {
              1: "위치와 관계없는 문서 실시간 암호화",
              2: "문서별 접근 권한 설정 및 사용성 제어",
              3: "랜섬웨어 대비 백업 및 복원 가능",
            },
          },
        },
        WRAPSODY_ECO: {
          name: "Wrapsody eCo",
          word: "공급망 데이터 보안 협업 플랫폼",
          description:
            "협업 그룹, 문서별로 권한을 설정해 공급망 내 데이터 보안도 빈틈없이 관리합니다.",
          moreInfo: {
            description: {
              1: "불편하고 불안했던 협업, Wrapsody eCo로 해결할 수 있습니다.",
              2: "프로젝트 별로 워크그룹을 생성해 외주 업체, 프리랜서 등 자주 소통하는 외부 인력들을 초대해 편리하게 협업이 가능합니다.",
              3: "도면, 계약서 등 협력사와 주고 받는 주요 문서별로 맞춤 권한을 설정해 공급망 내 데이터 보안도 빈틈없이 관리하세요.",
            },
            subTitle:
              "협업 그룹, 문서별로 권한을 설정해 공급망 내 데이터 보안도 빈틈없이 관리합니다.",
            features: {
              1: "프로젝트별 워크그룹 생성 및 외부 인원 초대",
              2: "복잡한 승인 과정 없는 안전한 보안 문서 공유",
              3: "아웃룩, 드롭박스 등 협업툴 통합 지원",
            },
          },
        },
        FIRESIDE: {
          name: "Fireside",
          description:
            "차세대 콘텐츠 중심 보안 메신저로 더 안전하면서도 효율적으로 협업이 가능합니다.",
          word: "차세대 콘텐츠 중심 보안 메신저",
          moreInfo: {
            description: {
              1: "모든 조직은 협업에서 중요 자료를 안전하게 보호하며, 효율적인 협업 환경을 구축해야 합니다.",
              2: "차세대 콘텐츠 중심 보안 메신저 Fireside는 더 안전하면서도 효율적인 협업을 돕습니다.",
              3: "주고받는 메시지와 파일 데이터를 암호화하고 민감정보는 자동으로 삭제해 이제 보안 걱정 없이 편리하게 소통하세요.",
            },
            subTitle:
              "차세대 콘텐츠 중심 보안 메신저로 더 안전하면서도 효율적으로 협업이 가능합니다.",
            features: {
              1: "메신저 내 메시지 및 문서 암호화",
              2: "민감정보 및 키워드 자동 삭제",
              3: "캡처 방지 및 스크린 워터마크 제공",
            },
          },
        },
        DSPM: {
          name: "Fasoo DSPM",
          description:
            "클라우드 환경에서도 중요 데이터 현황을 한눈에 파악해 잠재적 보안 위협을 최소화합니다.",
          word: "차세대 데이터 보안 태세 관리",
          moreInfo: {
            description: {
              1: "Fasoo DSPM을 통해 보유한 저장소내 중복되고, 미사용되고, 불필요한 데이터를 식별하고 관리할 수 있습니다.",
              2: "더불어 개인정보보호법을 비롯해 GDPR, HIPAA 등 국내외 컴플라이언스 규정 준수 상태를 저장소 및 데이터 단위로 파악하는 것도 가능합니다.",
              3: "이제 데이터 보안의 사각지대를 제거하고, 잠재적인 보안 위협에 한발 앞서 대응해보세요.",
            },
            subTitle:
              "클라우드 환경에서도 중요 데이터 현황을 한눈에 파악해 잠재적 보안 위협을 최소화합니다.",
            features: {
              1: "데이터 흐름을 안내하는 데이터 계보 기능",
              2: "빠르고, 정확한 스토리지 보안 상태 진단",
              3: "제대로 된 컴플라이언스 관리 프로세스",
            },
          },
        },
        FED: {
          name: "PC 문서 보안 (FED-N)",
          word: "제로 트러스트 기반의 문서보안",
          description:
            "제로 트러스트 기반의 문서보안 솔루션으로, 다양한 환경의 문서를 암호화합니다.",
          moreInfo: {
            description: {
              1: "사내에서 생성 및 유통되는 문서들의 보안은 데이터 보안의 기본입니다.",
              2: "특히, 가장 많이 사용하는 PC 환경은 반드시 빈틈없는 대비가 필요한 영역입니다.",
              3: "제로 트러스트 기반의 문서보안 솔루션 FED-N은 다양한 환경의 문서를 실시간으로 자동 암호화해 안전하게 관리할 수 있게 도와줍니다.",
              4: "예외 정책과 다양한 사용 권한 제어 기능을 제공해 다양한 예외 상황에도 유연하게 대응합니다.",
            },
            subTitle:
              "제로 트러스트 기반의 문서보안 솔루션으로, 다양한 환경의 문서를 암호화합니다.",
            features: {
              1: "이 기종 문서를 포함한 실시간 자동 암호화",
              2: "이미지 파일, CAD 도면 등 다양한 포맷 지원",
              3: "문서별 유연한 정책 관리 기능 제공",
            },
          },
        },
        FC_BR: {
          name: "문서 백업 (FC-BR)",
          word: "문서 중심 차세대 실시간 백업 솔루션",
          description:
            "자동으로 실시간 문서 백업을 진행해, 랜섬웨어 공격에 철저한 대비가 가능합니다.",
          moreInfo: {
            subTitle:
              "자동으로 실시간 문서 백업을 진행해, 랜섬웨어 공격에 철저한 대비가 가능합니다.",
            description: {
              1: "증가하는 사이버 공격으로 사내 문서 백업의 중요성이 더욱 커지고 있습니다. ",
              2: "FC-BR은 기존 스케줄링 방식이 아닌, 개별 문서 중심의 실시간 백업 기능을 지원하는 차세대 백업 솔루션입니다.",
              3: "문서 편집 후 종료 시 실시간으로 문서를 백업해 시기와 환경에 구애 받지 않고 문서를 보호할 수 있으며 미리보기 등으로 백업 파일을 상시 활용하고 필요시 빠르게 복구할 수 있습니다.",
            },
            features: {
              1: "실시간 자동 백업으로 랜섬웨어 대응 최적화",
              2: "사내 정책을 기반으로 한 백업 환경 설정",
              3: "백업 파일 미리보기 제공",
            },
          },
        },
        FSP: {
          name: "인쇄 보안 (FSP)",
          description:
            "출력물의 인쇄 및 유통 과정에서 발생할 수 있는 정보 유출을 방지합니다.",
          word: "출력물 유출 걱정 없는 안전한 인쇄",
          moreInfo: {
            description: {
              1: "전자문서 활용이 일상화된 현대 비즈니스 환경에서, 출력물은 보안이 가장 취약한 영역 중 하나로 꼽힙니다.",
              2: "FSP는 출력물의 인쇄 및 유통 과정에서 발생할 수 있는 정보 유출을 방지하는 출력물 보안 제품입니다.",
              3: "인쇄 권한을 세부적으로 통제하고, 인쇄 로그를 세밀하게 추적할 수 있으며 사내 출력물을 통합적으로 관리하며, 안전한 출력물 개인정보 보호 환경 구축이 가능합니다.",
            },
            subTitle:
              "출력물의 인쇄 및 유통 과정에서 발생할 수 있는 정보 유출을 방지합니다.",
            features: {
              1: "인쇄 이력 및 내용 추적",
              2: "비저블/인비저블 워터마크 제공",
              3: "중요 키워드 및 개인정보 마스킹",
            },
          },
        },
        FSS: {
          name: "화면 보안 (FSS)",
          description:
            "다양한 업무 환경에서 화면 캡처와 화면 직접 촬영을 통한 정보 유출을 차단합니다.",
          word: "업무 화면 보호를 위한 캡처 보안 솔루션",
          moreInfo: {
            subTitle:
              "다양한 업무 환경에서 화면 캡처와 화면 직접 촬영을 통한 정보 유출을 차단합니다.",
            description: {
              1: "기업 및 기관의 중요 정보가 그대로 노출되는 화면은 반드시 보안이 필요한 영역임에도 주요 보안 사각지대로 꼽히며 보안 적용이 어렵습니다.",
              2: "화면 보안 제품인 FSS는 다양한 업무 환경에서 화면 캡처와 화면 직접 촬영을 통해 정보 유출을 차단합니다.",
              3: "뿐만 아니라, 캡처 시도 및 내용을 기록해 발생할 수 있는 화면 정보 유출에도 대응할 수 있습니다.",
            },
            features: {
              1: "다양한 경로의 화면 캡처 시도 차단",
              2: "비저블/인비저블 스크린 워터마크 제공",
              3: "화면 캡처 시도 및 내역 조회 및 관리 기능",
            },
          },
        },
        FDR: {
          name: "Fasoo Data Radar",
          description:
            "모든 저장소의 개인정보 보유 현황을 파악하고 다양한 후처리 방법을 적용할 수 있습니다.",
          word: "개인정보 검출 관리부터 후처리까지",
          moreInfo: {
            subTitle:
              "모든 저장소의 개인정보 보유 현황을 파악하고 다양한 후처리 방법을 적용할 수 있습니다.",
            description: {
              1: "개인정보 유출 문제를 해결하기 위해서는 사내 모든 데이터를 식별, 분류, 모니터링하는 솔루션이 필요합니다.",
              2: "FDR은 기업 및 기관이 보유한 다양한 저장소의 중요 비정형데이터를 식별하고, 위치를 파악합니다.",
              3: "또, 중요도에 따라 허가 권한을 통제하고 사용 용도를 추적 및 분석하며, 취약점에 맞춰 다양한 보안 정책을 적용할 수 있습니다.",
            },
            features: {
              1: "모든 저장소의 개인정보 보유 현황 파악",
              2: "컴플라이언스 완벽 대응",
              3: "실시간 검사 및 다양한 후처리 옵션 제공",
            },
          },
        },
      },
    },
    error: {
      notFoundPage: {
        title: "페이지를 찾을 수 없습니다.",
        subTitle:
          "페이지의 주소가 잘못 입력되었거나, \n 변경 혹은 삭제되어 요청하신 페이지를 찾을 수가 없습니다.",
        goToMainBtn: {
          eco: "Wrapsody eCo Cloud 로 이동",
          wrapsody: "Wrapsody Cloud 로 이동",
        },
      },
    },

    // leftMenu
    navBar: {
      leftMenu: {
        siteManagement: "사이트 관리",
        paymentHistory: "구매 이력",
      },
      home: {
        mainFeatures: "주요 기능",
        productPurchase: "제품 구매",
        inquiry: "제품 문의",
        company: "회사 소개",
        console: "콘솔",
      },
      companyName: "© Fasoo Co., Ltd.",
      myAccount: {
        fieldname: "내 계정",
        logout: "로그아웃",
        basicInfo: "기본 정보",
        withDrawal: "회원 탈퇴",
        name: "이름",
        edit: "변경",
        companyName: "회사 이름",
        email: "이메일",
        password: "비밀번호",
        popUp: {
          commonCheckMsg: "변경 사항이 반영되지 않았습니다. 다시 시도해주세요.",
          changeEmail: {
            title: "이메일 주소 변경",
            enterEmail: "새 이메일 주소",
            confirmEmailAddress: "이메일 주소 확인",
            password: "비밀번호",
            checkMsg1: "새 이메일 주소를 입력하세요.",
            checkMsg2: "이메일 주소 확인을 진행하세요.",
            checkMsg3: "잘못된 형식의 이메일입니다.",
            checkMsg4: "현재 이메일과 동일합니다.",
            checkMsg5: "이메일이 변경되었습니다.",
            checkMsg6: "이메일 주소가 일치하지 않습니다.",
            checkMsg7: "비밀번호를 입력하세요.",
            checkMsg8: "이메일이 일치하지 않습니다.",
          },
          changePassword: {
            title: "비밀번호 변경",
            enterCurrentPassword: "현재 비밀번호",
            enterNewPassword: "새 비밀번호",
            confirmPassword: "새 비밀번호 확인",
            checkMsg1: "현재 비밀번호를 입력하세요.",
            checkMsg2: "새 비밀번호를 입력하세요.",
            checkMsg3: "새 비밀번호 확인을 진행하세요.",
            checkMsg4:
              "비밀번호는 6~16자 영문 대소문자, 숫자, 특수문자를 포함해야 합니다.",
            checkMsg5: "비밀번호가 일치하지 않습니다. ",
            checkMsg6: "비밀번호가 변경되었습니다.",
            usedPassword: "최근 사용했던 비밀번호는 다시 사용할 수 없습니다.",
          },
          changeName: {
            title: "이름 변경",
            enterName: "새 이름을 입력해주세요.",
            checkMsg1: "변경할 이름을 입력하세요.",
            checkMsg2: "입력된 이름이 너무 짧습니다.",
            checkMsg3: "현재 이름과 동일합니다.",
            checkMsg4: "이름이 변경되었습니다.",
          },
          withDrawal: {
            title: "회원 탈퇴",
            withDrawalInfo:
              "사이트를 보유하고 있는 운영자는 탈퇴가 불가능합니다.",
            withDrawalInfo_2:
              "사이트 삭제 후에 회원 탈퇴를 진행할 수 있습니다.",
            leaveMember: "파수 클라우드포탈에서 탈퇴하시겠습니까?",
            leaveOk: "탈퇴 처리되었습니다.",
          },
        },
      },
      notifications: {
        title: "알림",
        mark: "모두 읽음 처리",
        close: "오늘은 그만 보기",
      },
      contact: {
        QnA: "문의하기",
        customerCenter: "고객센터",
        contactSupport: "문의하기",
        FAQ: "자주 묻는 질문",
        cloudCs: "클라우드 고객 지원",
      },
    },
    // 로그인
    logIn: {
      title: "로그인",
      userEmail: "이메일 주소",
      password: "비밀번호",
      rememberId: "ID 저장",
      findPassword: "비밀번호를 잊으셨나요?",
      goToLoginBtn: "로그인",
      checkMember: "계정이 없으신가요?",
      goToSignUp: "가입하기",
      enterUserId: "ID를 입력하세요.",
      enterCompanyName: "회사 이름을 입력하세요.",
      enterUserEmail: "이메일 주소를 입력하세요.",
      enterPassword: "비밀번호를 입력해주세요.",
      enterName: "이름을 입력하세요.",
      invalidUser: "존재하지 않는 사용자 ID 또는 잘못된 비밀번호입니다.",
      successMsg: "환영합니다! 로그인에 성공했습니다.",

      //회원가입
      signUp: {
        title: "회원가입",
        email: "이메일 주소",
        emailCheckMsg: "이메일은 최대 {0}자 이내로 입력해주세요.",
        name: "이름",
        nameCheckMsg: "이름은 최대 {0}자 이내로 입력해주세요.",
        companyName: "회사 이름",
        password: "비밀번호",
        passwordHint: "숫자, 영문 대소문자, 특수 문자를 포함한 8-16자",
        confirmPassowrd: "비밀번호 확인",
        enterConfirmPassowrd: "비밀번호 재입력",
        agreement1: "",
        agreement2: "통합 이용약관",
        agreement3: " 및",
        agreement4: " 개인정보처리방침",
        agreement5: " 에 동의합니다.",
        goToSignUpBtn: "회원가입",
        checkMember: "이미 계정이 있으신가요?",
        goToLogin: "로그인",
        invalidEmail: "이메일 형식이 맞지 않습니다.",
        invalidEmailFormat: "올바른 이메일 형식이 아닙니다.",
        agreement: "통합 이용약관 및 개인정보처리방침에 동의해주세요.",
        validEmail: "사용할 수 있는 이메일 주소입니다.",
        usedId: "사용할 수 없는 이메일 주소입니다.",
        regexPassword:
          "비밀번호는 6~16자 영문 대소문자, 숫자, 특수문자를 포함해야 합니다.",
        validPassword: "사용할 수 있는 비밀번호 입니다.",
        invalidPasswordFormat: "숫자, 영문 대소문자, 특수 문자를 포함한 8-16자",
        invalidPassword: "비밀번호가 일치하지 않습니다.",
        completed: "회원 가입이 완료되었습니다.",
        completedTitle: "가입 완료",

        joinBox: {
          title_1: "Fasoo Cloud",
          title_2: "가입을 환영합니다!",
          // title_3: '을 환영합니다!',
          description_1: "Fasoo Cloud 통합 회원으로 가입하시면",
          description_2: "Fasoo의 다양한 Cloud 제품을",
          description_3: "하나의 통합 ID로",
          description_4: "편리하게 이용하실 수 있습니다.",
        },
        //인증
        otp: {
          title: "인증번호",
          sendBtn: "인증번호 받기",
          confirmBtn: "인증 확인",
          enterMsg: "8자리 숫자 입력",
          sendTokenMsg: "인증번호가 입력하신 이메일 주소로 발송됐습니다.",
          successMsg: "인증이 완료되었습니다.",
          infoMsg: "이미 메일을 전송했습니다. 잠시 후 다시 시도하세요.",
          mismatchMsg: "인증번호가 일치 하지 않습니다.",
        },
      },

      // 비밀번호 재설정
      resetPassowrd: {
        title: "비밀번호를 잊으셨나요?",
        resetPasswordBtn: "비밀번호 재설정",
        goBackToLogin: "로그인 페이지로 돌아가기",
        confirmAlert:
          "회원님의 이메일 계정으로 임시 비밀번호를 보냈습니다.\n비밀번호는 로그인 후 내 계정 메뉴에서 변경할 수 있습니다.",
      },

      stepBar: {
        step1: "회원가입/로그인",
        step2: "구독 결제 정보 입력",
        step3: "사이트 생성",
        step2Apply: "신청 정보 입력",
        step2Pay: "결제 정보 입력",
        step2Coupon: "쿠폰 정보 입력",
      },
    },

    // 요금제 type
    subscriptionType: {
      title: "Wrapsody eCo Cloud 요금제",
      shortTitle: "{0} Cloud 요금제",
      subTitle: "요금제를 선택해주세요.",
      shortsubTitle: "요금제를 선택해주세요.",
      showMore: "더 많은 기능 표시",
      hide: "더 많은 기능 접기",
      dollar: "US",
      noticeMsg1: "요금제 관련 공지",
      alreadyCreatedMsg: "기존에 생성한 사이트가 존재합니다.",
      limitFreeTrial:
        "무료 체험 및 사이트 생성 이력이 없는 신규 사용자에게만 제공됩니다.",
      type: {
        free_1: "무료 체험",
        free_2: "무료 체험",
        basic: "Basic",
        plus: "Plus",
        premium: "Premium",
      },
      fee: {
        free: "15일 무료",
        basic: "$12",
        plus: "$25",
        premium: "개별 문의",
        won: "₩",
        dollar: "$",
      },
      monthlyPerPerson: "사용자당 월",
      minimumPerPerson: "사용자당 매월 최소 10명 기준",
      overThousandPerson: "",
      annualPayment: "연간 결제 기준",
      description: {
        free: "15일간 {0} 무료 체험",
        drive: "사내 문서관리 체계의 시작.\n가장 사용하기 쉬운 파일 관리 환경",
        basic:
          "안전한 파일 공유 및 공동 작업\n소규모 외부 사용자와 협업에 최적화",
        wrapsodyDrive:
          "사내 문서관리 체계의 시작. 가장 단순하면서 사용하기 쉬운 파일 관리",
        wrapsodyBasic: "위치와 상관없이 문서관리가 필요한\n고객(팀)에게 추천",
        basicPlus:
          "기본 암호화 확장자 외 도면, 이미지, 동영상 등 주요 파일을 안전하게 암호화",
        plus: "더 많은 용량이 필요한 프로젝트\n더 많은 외부 사용자와 협업에 최적화 ",
        enterprise: "고도화된 데이터 보호가 필요한\n고객(팀)에게 추천",
        plusPlus:
          "보안 기능과 함께 추가 Application 지원으로 엄격한 보안 유지가 필요한 고객에게 최적화",
        premium:
          "기존 시스템 연동 및 웹 미리보기 제공\n디바이스 제한없는 끊임없는 업무 환경",
        wrapsodyPremium: "맞춤형 서비스가 필요한\n고객(팀)에게 추천",
      },
      terms: {
        eco: {
          free_1: "전체 100GB 제공",
          free_2: "사용자 최대 10명 ",
          free_3: "1인당 외부 사용자 5명 초대",
          basic_1: "공유 스토리지\n: 사용자 수 × 50GB",
          basic_2: "외부 사용자 초대\n: 사용자 수 × 10명",
          basic_3: "버전 관리 기능 제공",
          basic_4: "스마트 동기화",
          basic_5: "데이터 암호화",
          basic_6: "모바일 액세스",
          plus_1: "공유 스토리지\n: 사용자 수 × 100GB",
          plus_2: "외부 사용자 초대\n: 사용자 수 × 20명",
          plus_3: "버전 관리 기능 제공",
          plus_4: "스마트 동기화",
          plus_5: "데이터 암호화",
          plus_6: "모바일 액세스",
          plus_7: "애플리케이션 추가 지원",
          premium_1: "용량 지정 가능",
          premium_2: "사용자 및 초대 인원 지정 가능",
          premium_3: "유료 요금제의 모든 기능 포함",
          premium_4: "Office 365  연동 가능",
          premium_5: "Fasoo 제품 연동 가능",
          premium_6: "사용자 및 관리자 교육 제공",
          premium_7: "애플리케이션 추가 지원",
        },
        wrapsody: {
          free_1: "전체 50GB 제공",
          free_2: "Standard 요금제 최초 15일 무료 체험",
          drive_1: "사용자당 50GB 제공",
          drive_2: "폴더별 파일 관리",
          drive_3: "웹 미리보기",
          drive_4: "스마트 동기화",
          drive_5: "모바일 전용 APP",
          // drive_6: 'spec 6',
          basic_1: "사용자당 50GB 제공",
          basic_2: "Basic 요금제 기능 포함",
          basic_3: "세분화된 문서 권한 관리",
          basic_4: "스마트 클리너",
          basic_5: "폴더별 파일 관리",
          basic_6: "웹 미리보기",
          basicPlus_1: "사용자당 50GB 제공",
          basicPlus_2: "Standard 요금제 기능 포함",
          basicPlus_3: "추가 애플리케이션 지원",
          basicPlus_4: " ",
          basicPlus_5: " ",
          basicPlus_6: " ",
          plus_1: "사용자당 100GB 제공",
          plus_2: "Standard 요금제 기능 포함",
          plus_3: "로컬 PC 저장 제어",
          plus_4: "파일 무단 유출 방지",
          plus_5: "예외/요청 승인 프로세스",
          plus_6: " ",
          plusPlus_1: "사용자당 100GB 제공",
          plusPlus_2: "Enterprise 요금제 기능 포함",
          plusPlus_3: "추가 애플리케이션 지원",
          plusPlus_4: " ",
          plusPlus_5: " ",
          plusPlus_6: " ",
          premium_1: "위치와 관계없는 문서 실시간 암호화",
          premium_2: "문서별 접근 권한 설정 및 사용성 제어",
          premium_3: "랜섬웨어 대비 백업 및 복원 가능",
          premium_4: "조직 및 문서 기반 채팅(Fireside)",
          premium_5: "연동 및 기타 맞춤형\n서비스 제공",
          premium_6: "관리자 교육",
        },
        dspm: {
          premium_1: "데이터 흐름을 안내하는 데이터 계보 기능",
          premium_2: "빠르고, 정확한 스토리지 보안 상태 진단",
          premium_3: "제대로 된 컴플라이언스 관리 프로세스",
        },
        dsp: {
          premium_1: "통합 데이터 보안",
          premium_2: "예외 정책 관리 결재 시스템 포함",
          premium_3: "문서/화면/출력/백업 등 조합 선택 가능",
        },
        fireside: {
          premium_1: "메시지 및 파일 데이터 암호화",
          premium_2: "민감 정보 자동 삭제",
          premium_3: "AI 연동 및 챗봇 활용",
        },
      },
      startSubscriptionBtn: {
        eco: {
          free: "시작하기",
          basic: "시작하기",
          plus: "시작하기",
          premium: "시작하기",
        },
        wrapsody: {
          free: "시작하기",
          drive: "시작하기",
          basic: "시작하기",
          basicPlus: "시작하기",
          plus: "시작하기",
          plusPlus: "시작하기",
          premium: "시작하기",
        },
        fireside: {
          premium: "시작하기",
        },
      },

      keyFeatures: {
        wrapsody: {
          feature: "핵심 기능",
          feature_0: "저장 공간",
          feature_1: "폴더별 파일 관리\n(랩소디 드라이브)",
          feature_2: "고급 검색 기능\n(본문 검색, 고급 필터 제공)",
          feature_3: "클라우드 스토리지 내 데이터 암호화",
          feature_4: "모바일 전용 APP",
          feature_5: "웹오피스 기반의 문서 협업",
          feature_6: "고객사별 암호 키 관리",
          feature_7: "로컬에서 문서작업 시 파일 동기화",
          feature_8: "문서 위치와 상관없는 자동 버전 관리",
          feature_9: "문서 사용 내역 가시화 및 추적",
          feature_10: "자동 백업 및 문서 복구 기능",
          feature_11: "스마트 클리너 제공",
          feature_12: "예외 요청/승인",
          feature_13: "문서 보안 강화 PACK",
          feature_14: "세분화된 문서 권한 관리",
          feature_15: "문서 로컬 PC저장 통제",
          feature_16: "인쇄 시 워터마크 출력",
          feature_17: "기업용 보안 메신저",
          feature_18: "하이브리드 클라우드 저장소",
          feature_19: "사내 시스템 연동 API 제공",
          feature_20: "조직도 연동",
          feature_21: "관리자 교육",
          bottom: "추가 애플리케이션 지원",

          // feature_22: '로컬 저장 통제',
          // feature_23: '파일 및 문서 기반 채팅',
          // feature_24: '사내 전용 스토리지 연동',
          // feature_25: '분산 스토리지 연동',
          // feature_26: '사내 시스템 연동 API 제공',
          // feature_27: '워터마크 출력',
          // feature_28: '관리자 교육',
          // feature_29: 'SSO 연동',
          // feature_30: '추가 애플리케이션 지원',

          // feature_0: '저장 공간',
          // feature_1: '세분화된 액세스 제어',
          // feature_2: '전체 스토리지 용량 공유',
          // feature_3: '암호화 문서 편집 및 열람',
          // feature_4: '효율적인 사용자 관리',
          // feature_5: '모바일 보안 제어',
          // feature_6: '완전한 문서 추적 및 관리',
          // feature_7: '전체 사용자 활동 추적',
          // feature_8: '암호 정책 요구사항 준수',
          // feature_9: '스마트 동기화',
          // feature_10: '파일 이벤트 추적',
          // feature_11: '웹 미리보기',
          // feature_12: '통합 관리 콘솔',
          // feature_13: '도메인 통계',
          // feature_14: '웹 리비전',
          // feature_15: 'Fasoo 제품 연동 (단일 계정 로그인)',
          // feature_16: '맞춤형 브랜딩',
          // feature_17: '사용자에게 관리자 역할 부여',
          // feature_18: '파일 본문 검색',
          // feature_19: '스마트 클리너 제공',
          // feature_20: '랩소디 드라이브',
          // feature_21: '문서 보안 강화 PACK',
          // feature_22: '로컬 저장 통제',
          // feature_23: '파일 및 문서 기반 채팅',
          // feature_24: '사내 전용 스토리지 연동',
          // feature_25: '분산 스토리지 연동',
          // feature_26: '사내 시스템 연동 API 제공',
          // feature_27: '워터마크 출력',
          // feature_28: '관리자 교육',
          // feature_29: 'SSO 연동',
          // feature_30: '추가 애플리케이션 지원',
        },
        eco: {
          feature: "핵심 기능",
          feature_0: "최소 유저",
          feature_0_1: "10 명",
          feature_1: "저장공간",
          feature_2: "외부 사용자",
          feature_3: "세분화된 엑세스 제어",
          feature_4: "전체 스토리지 용량 공유",
          feature_5: "암호화 문서 편집 및 열람",
          feature_6: "효율적인 사용자 관리",
          feature_7: "모바일 보안 제어",
          feature_8: "완벽한 문서 추적 및 관리",
          feature_9: "전체 사용자 활동 추적",
          feature_10: "암호 정책 요구사항 준수",
          feature_11: "스마트 동기화",
          feature_12: "파일 이벤트 추적",
          feature_13: "웹 미리보기",
          feature_14: "통합 관리 콘솔",
          feature_15: "도메인 통계",
          // feature_16: "추가 애플리케이션 지원",
          feature_16: "웹리비전",
          feature_17: "Fasoo 제품 연동 (단일 계정 로그인)",
          feature_18: "맞춤형 브랜딩",
          feature_19: "사용자에게 관리자 역할 부여",
          bottom: "추가 응용 프로그램 지원",
        },
        dspm: {
          feature: "핵심 기능",
        },
        dsp: {
          feature: "핵심 기능",
        },
        fireside: {
          feature: "핵심 기능",
        },
        terms: {
          free_1: "전체 50GB",
          drive_1: "사용자당 50GB",
          basic_1: "사용자당 50GB",
          basic_2: "1인당 10명",
          basicPlus_1: "사용자당 50GB",
          plus_1: "사용자당 100GB",
          plus_2: "1인당 20명",
          plusPlus_1: "사용자당 100GB",
          premium_1: "용량 지정 가능",
          premium_2: "지정 가능",
        },
      },
    },
    siteType: {
      tab1: "통합 이용약관",
      tab2: "개인정보처리방침",
      tab3: "유료 이용약관",
      subscribeBtn: "구독하기",
      send: "문의하기",
      agreement1: "",
      agreement2: "통합 이용약관",
      agreement3: ", ",
      agreement4: "개인정보처리방침",
      agreement5: ", ",
      agreement6: "유료 이용약관",
      agreement7: "에 동의합니다.",
      agreement: "이용 약관, 유료 이용 약관, 개인정보처리방침에 동의해주세요.",
      info: "* 서비스 구독 기간 만료 30일 후에는 모든 데이터가 삭제됩니다.",
      alert: {
        Msg1: "프리미엄 기간을 확인해주세요.",
        Msg2: "내부 사용자 수를 확인해주세요.",
        Msg3: "사용자 당 외부 사용자 수를 확인해주세요.",
        Msg4: "사용자 당 용량을 확인해주세요.",
      },
      subscriptionType: {
        eco: {
          subscriptionType_free: "무료 체험",
          subscriptionType_basic: "Basic",
          subscriptionType_plus: "Plus",
          subscriptionType_premium: "Premium",
        },
        wrapsody: {
          subscriptionType_free: "무료 체험",
          subscriptionType_drive: "Basic",
          subscriptionType_basic: "Standard",
          subscriptionType_basicPlus: "Standard Plus",
          subscriptionType_plus: "Enterprise",
          subscriptionType_plusPlus: "Enterprise Plus",
          subscriptionType_premium: "Premium",
        },
        dspm: {
          subscriptionType_premium: "Premium",
        },
        dsp: {
          subscriptionType_premium: "Premium",
        },
        fireside: {
          subscriptionType_premium: "Premium",
        },
      },
      paymentSuccess: "결제가 완료되었습니다.",
      referralIdOptional: "영업담당자 입력 (선택)",
      application: "e",
      referralId: "영업담당자",
      manager: "담당자",
      managerId: "담당자 ID",
      changeManager: "담당자 변경",
      enterIdEmail: "아이디 또는 이메일 주소",
      referral_title: "영업담당자 입력(선택)",
      referral_id: "아이디 또는 이메일 주소",
      title: "{0} Cloud {1}",
      subTitle: "유료 서비스를 사용하시려면 아래 정보를 입력해주십시오",
      free: {
        title: "{0} Cloud 무료 체험",
        subTitle:
          "아래 정보 입력 후 신청하기를 누르시면 검토 후 이메일로 연락드립니다.",
        detail: {
          title: "사용자 정보",
          username: "담당자 이름",
          enterUserName: "담당자 이름",
          phoneNumber: "담당자 연락처(전화번호)",
          enterPhoneNumber: "담당자 연락처(전화번호)",
          company: "회사 또는 기관명",
          enterCompany: "회사 또는 기관명",
          purpose: "사용 목적",
          info: "* 무료 체험 기간 만료 후에는 모든 데이터가 삭제됩니다.",
          alertMsg1: "사용자 이름은 최대 50자 이내로 입력해주세요.",
          alertMsg2: "연락처는 최대 30자 이내로 입력해주세요.",
          alertMsg3: "사용 기관은 최대 100자 이내로 입력해주세요.",
          alertMsg4: "사용 목적은 최대 500자 이내로 입력해주세요.",
          alertMsg5: "담당자 연락처(전화번호)를 입력해주세요.",
        },
        orderSpecification: {
          title: "신청 내역",
          planType: "요금제",
          showMore: "모든 기능 보기",
          hide: "접기",
          startBtn: "신청하기",
        },
      },
      drive: {
        title: "Wrapsody eCo Cloud Drive",
        subTitle: "유료 서비스를 사용하시려면 아래 정보를 입력해주십시오",
        detail: {
          plan: {
            title: "요금제 세부 정보",
            userNum: "사용자",
            userNumCheckMsg:
              "사용자 수는 {0}명 이상 {1}명 이하로 입력해주세요.",
            paymentCycle: "결제 주기",
            payType_month: "매달 결제",
            price_condition_per_user: "1인당 ",
            price_condition_monthly: "/월",
            annual_sum: "연간 합산액",
            payType_annual: "연 1회 결제",
            price_condition_annual: "/년",
            discount: "20% 절약",
          },
          payment: {
            title: "결제 정보",
            info: "기타 방법으로 결제하려면 문의하기에서 진행해주세요.",
            info_1:
              "기타 방법으로 결제하려면 <b> 문의하기에서 진행해주세요. </b>",
            info_2: "",
            info_3: "",
            cardNum: "신용카드 번호",
            expirationDate: "만료일",
            enterExpirationDate: "월/년",
            csc: "보안코드",
            country: "국가",
            zipcode: "우편번호",
          },
        },
        orderSpecification: {
          title: "서비스 구독 내역",
          planType: "요금제",
          showMore: "모든 기능 보기",
          hide: "접기",
          subscription: "서비스 구독",
          price: "금액",
          subscribedUsers: "사용자 {0} 명",
          year: "/년",
          month: "/월",
          annulDiscount: "연간 구매 할인",
          total: "합계",
        },
      },
      basic: {
        title: "Wrapsody eCo Cloud Basic",
        subTitle: "유료 서비스를 사용하시려면 아래 정보를 입력해주십시오",
        detail: {
          plan: {
            title: "요금제 세부 정보",
            userNum: "사용자",
            userNumCheckMsg:
              "사용자 수는 {0}명 이상 {1}명 이하로 입력해주세요.",
            paymentCycle: "결제 주기",
            payType_month: "매달 결제",
            price_condition_per_user: "1인당 ",
            price_condition_monthly: "/월",
            annual_sum: "연간 합산액",
            payType_annual: "연 1회 결제",
            price_condition_annual: "/년",
            discount: "20% 절약",
          },
          payment: {
            title: "결제 정보",
            info: "기타 방법으로 결제하려면 문의하기에서 진행해주세요.",
            info_1:
              "기타 방법으로 결제하려면 <b> 문의하기에서 진행해주세요. </b>",
            info_2: "",
            info_3: "",
            cardNum: "신용카드 번호",
            expirationDate: "만료일",
            enterExpirationDate: "월/년",
            csc: "보안코드",
            country: "국가",
            zipcode: "우편번호",
          },
        },
        orderSpecification: {
          title: "서비스 구독 내역",
          planType: "요금제",
          showMore: "모든 기능 보기",
          hide: "접기",
          subscription: "서비스 구독",
          price: "금액",
          subscribedUsers: "사용자 {0} 명",
          year: "/년",
          month: "/월",
          annulDiscount: "연간 구매 할인",
          total: "합계",
        },
      },
      basicPlus: {
        title: "Wrapsody Cloud Standard Plus",
        subTitle: "유료 서비스를 사용하시려면 아래 정보를 입력해주십시오",
        detail: {
          plan: {
            title: "요금제 세부 정보",
            userNum: "사용자",
            userNumCheckMsg:
              "사용자 수는 {0}명 이상 {1}명 이하로 입력해주세요.",
            paymentCycle: "결제 주기",
            payType_month: "매달 결제",
            price_condition_per_user: "1인당 ",
            price_condition_monthly: "/월",
            annual_sum: "연간 합산액",
            payType_annual: "연 1회 결제",
            price_condition_annual: "/년",
            discount: "20% 절약",
          },
          payment: {
            title: "결제 정보",
            info: "기타 방법으로 결제하려면 문의하기에서 진행해주세요.",
            info_1:
              "기타 방법으로 결제하려면 <b> 문의하기에서 진행해주세요. </b>",
            info_2: "",
            info_3: "",
            cardNum: "신용카드 번호",
            expirationDate: "만료일",
            enterExpirationDate: "월/년",
            csc: "보안코드",
            country: "국가",
            zipcode: "우편번호",
          },
        },
        orderSpecification: {
          title: "서비스 구독 내역",
          planType: "요금제",
          showMore: "모든 기능 보기",
          hide: "접기",
          subscription: "서비스 구독",
          price: "금액",
          subscribedUsers: "사용자 {0} 명",
          year: "/년",
          month: "/월",
          annulDiscount: "연간 구매 할인",
          total: "합계",
        },
      },
      plus: {
        title: "Wrapsody eCo Cloud Plus",
        subTitle: "유료 서비스를 사용하시려면 아래 정보를 입력해주십시오",
        detail: {
          plan: {
            title: "요금제 세부 정보",
            userNum: "사용자",
            paymentCycle: "결제 주기",
            payType_month: "매달 결제",
            price_condition_per_user: "1인당 ",
            price_condition_monthly: "/월",
            annual_sum: "연간 합산액",
            price_condition_annual: "/년",
            payType_annual: "연 1회 결제",
            price_condition_year: "/년",
            discount: "20% 절약",
          },
          payment: {
            title: "결제 정보",
            info: "기타 방법으로 결제하려면 문의하기에서 진행해주세요.",
            cardNum: "신용카드 번호",
            expirationDate: "만료일",
            enterExpirationDate: "월/년",
            csc: "보안코드",
            country: "국가",
            zipcode: "우편번호",
          },
        },

        orderSpecification: {
          title: "서비스 구독 내역",
          planType: "요금제",
          showMore: "모든 기능 보기",
          hide: "접기",
          subscription: "서비스 구독",
          price: "금액",
          subscribedUsers: "사용자 {0}명",
          year: "/년",
          month: "/월",
          annulDiscount: "연간 구매 할인",
          total: "합계",
        },
      },
      plusPlus: {
        title: "Wrapsody Cloud Enterprise Plus",
        subTitle: "유료 서비스를 사용하시려면 아래 정보를 입력해주십시오",
        detail: {
          plan: {
            title: "요금제 세부 정보",
            userNum: "사용자",
            paymentCycle: "결제 주기",
            payType_month: "매달 결제",
            price_condition_per_user: "1인당 ",
            price_condition_monthly: "/월",
            annual_sum: "연간 합산액",
            price_condition_annual: "/년",
            payType_annual: "연 1회 결제",
            price_condition_year: "/년",
            discount: "20% 절약",
          },
          payment: {
            title: "결제 정보",
            info: "기타 방법으로 결제하려면 문의하기에서 진행해주세요.",
            info_1: "",
            info_2: "",
            info_3: "",
            cardNum: "신용카드 번호",
            expirationDate: "만료일",
            enterExpirationDate: "월/년",
            csc: "보안코드",
            country: "국가",
            zipcode: "우편번호",
          },
        },

        orderSpecification: {
          title: "서비스 구독 내역",
          planType: "요금제",
          showMore: "모든 기능 보기",
          hide: "접기",
          subscription: "서비스 구독",
          price: "금액",
          subscribedUsers: "사용자 {0}명",
          year: "/년",
          month: "/월",
          annulDiscount: "연간 구매 할인",
          total: "합계",
        },
      },
      premium: {
        title: "Wrapsody eCo Cloud Premium",
        subTitle: "프리미엄 서비스를 이용하려면 아래 내용을 입력해주십시오.",
        askTitle: "맞춤형 요금제 상담 문의",
        askSubTitle: "원하는 요금제 세부 정보를 입력한 후 문의해주세요.",
        continueTitle: "요금제 세부 정보 변경 문의",
        continueSubTitle: "원하는 요금제 세부 정보를 입력한 후 문의해주세요.",
        detail: {
          plan: {
            title: "요금제 세부 정보",
            promotionCode: "프리미엄 코드",
            enterPromotionCode: "프리미엄 코드를 입력하세요",
            registerBtn: "등록",
            validPromotionCode: "유효한 코드입니다.",
            invalidPromotionCode: "코드가 유효하지 않습니다.",
            expirationDate: "구독 종료일",
            availablePeriods: "코드 유효 기간",
            days: "{0} 일",
            until: " 까지",
            userNum: "사용 가능 인원",
            person: "{0} 명",
            haveCode: "프리미엄 코드가 있으신가요?",
            dontHaveCode: "프리미엄 코드가 없으신가요?",
            contactInfo: "연락처 (전화번호, 이메일)",
            comment: "기타 문의 사항",
            period: "구독 희망 기간",
            startDate: "시작일",
            endDate: "종료일",
            userStorage: "사용자당 스토리지 용량 (GB)",
            userStorageCheckMsg:
              "사용자 당 스토리지 용량은 최소 {0}GB, 최대{1}GB이어야 합니다.",
            userExtenalInvite: "외부 초대 인원",
            userExtenalInviteCheckMsg:
              "사용자당 외부 초대 인원은 {0}명 이상 {1}명 이하로 입력해주세요.",
            user: "사용자",
            alert: {
              Msg1: "이미 신청하였습니다.",
            },
            package: {
              dsp_1: "문서 보안",
              dsp_2: "출력물 보안",
              dsp_3: "화면 보안",
              dsp_4: "문서 DR",
              dsp_5: "문서 보안+ 패키지",
              dsp_6: "문서 보안 및 DR 패키지",
              dsp_7: "개인정보 보호 패키지",
              dsp_8: "데이터 통합 보안 패키지",
            },
          },
          partnerInfo: {
            title: "고객사 정보",
            emailAddress: "담당자 이메일",
            purpose: "사용 목적",
            enterPurpose:
              "도입 목적이나 사용 계획을 간단히 적어주시면, 보다 정확한 안내에 도움이 됩니다. 빠르게 연락드리겠습니다.",
          },
        },

        orderSpecification: {
          title: "서비스 구독 내역",
          planType: "요금제",
          showMore: "모든 기능 보기",
          hide: "접기",
        },
      },

      //요금제 문의
      inquiry: {
        customizedPayment: "맞춤형 요금제 상담 문의",
        customizedPayment_desc:
          "원하는 요금제 세부 정보를 입력한 후 문의해주세요.",
        changePayment: "요금제 세부 정보 변경 문의",
        changePayment_desc: "원하는 요금제 세부 정보를 입력한 후 문의해주세요.",
        inquiryBtn: "문의하기",
      },

      complete: {
        title: "무료 체험 신청이 접수되었습니다.",
        subTitle: "최대한 빠른 시일 내에 결과를 이메일로 알려드리겠습니다.",
        goToMainBtn: "다음 단계로",
      },

      promotionApply: {
        title: "프리미엄 요금제 문의가 접수되었습니다.",
        subTitle: "최대한 빠른 시일 내에 결과를 이메일로 알려드리겠습니다.",
        goToMainBtn: "프리미엄 구독하기",
        goToConsoleBtn: "사이트 관리로 이동",
      },

      promotionApplied: {
        title: "프리미엄 코드가 적용되었습니다.",
        subTitle: "이제 Wrapsody eCo Cloud를 이용할 수 있습니다.",
        goToMainBtn: "사이트 만들기",
      },
    },

    siteManagement: {
      title: "사이트 관리",
      subTitle: "사이트를 만들어보세요.",
      info: "사이트 만들기 버튼을 누르면 사이트를 만들 수 있습니다.",
      createBtn: "사이트 만들기",
      upgradeBtn: "업그레이드",
      useWrapsody: "이제 Wrapsody를 이용할 수 있습니다.",
      nextStep: "다음 단계로",
      expirationInfo: {
        eco: "무료 체험이 {0}일 후 종료됩니다. Wrapsody eCo Cloud를 계속 사용하려면 결제정보를 추가하세요.",
        wrapsody:
          "무료 체험이 {0}일 후 종료됩니다. Wrapsody Cloud를 계속 사용하려면 결제정보를 추가하세요.",
      },
      info1: {
        Msg1: "무료 체험이 {0}에 종료됩니다. 유료 요금제로 전환하여 안정적인 서비스를 경험해보세요.",
        Msg2: "[{0}] 구독 중입니다. 다음 결제일은 {1} 입니다.",
        Msg3: "[{0}]에 대한 결제에 실패하였습니다. {1}에 서비스 구독이 종료됩니다.",
        Msg4: "[{0}] 구독이 {1}에 만료됩니다. 사이트를 계속 운영하려면 재구독을 진행해주세요.",
        // Msg5: "[{0}] 구독 만료일로부터 30일이 경과하는 {1}에 사이트가 삭제 될 예정입니다. 사이트를 유지하려면 결제를 진행해주세요.",
        Msg5: "[{0}] 구독 만료일로부터 30일이 경과하는 {1}에 사이트가 삭제 될 예정입니다. 사이트를 유지하려면 {2} 담당자에게 문의해주세요.",
      },
      notice: {
        cancleSubscription1: "정기결제를 해지하시겠습니까?",
        cancleSubscription2:
          "구독 기간이 종료되는 {0}까지 서비스 이용이 가능하며, 해당 날짜 이전에는 언제든지 재구독할 수 있습니다.",
        resubscribe1: "재구독하시겠습니까?",
        resubscribe2: "구독이 즉시 재개되며, 다음 구독료 청구일은 {0}입니다.",
        comfirmPay:
          "기존 결제 수단으로 결제가 진행됩니다. 라이선스 발급 및 저장 용량 증설 등의 사유로 결제를 진행하는 경우 취소 및 환불이 불가능합니다. 결제를 진행하시겠습니까?",
      },
      free: {
        beforeApplication: {
          title: "무료 체험 신청이 접수되었습니다.",
          subTitle: "최대한 빠른 시일 내에 결과를 이메일로 알려드리겠습니다.",
          goToMainBtn: "다음 단계로",
          upgradeInfoMsg:
            "유료 전환 시 바로 서비스 이용이 가능합니다. 유료로 전환하시겠습니까?",
          upgradeBtn: "유료 전환하기",
        },
        afterApplication: {
          title: "신청이 승인되었습니다.",
          subTitle: "사이트를 생성해주세요.",
          goToMainBtn: "사이트 생성하기",
        },
      },
      premium: {
        beforeApplication: {
          title: "프리미엄 요금제 문의가 접수되었습니다.",
          subTitle: "최대한 빠른 시일 내에 결과를 이메일로 알려드리겠습니다.",
          goToMainBtn: "메인 화면으로",
        },
        afterApplication: {
          title: "프리미엄 코드가 적용되었습니다.",
          subTitle: "이제 Wrapsody를 이용할 수 있습니다.",
          goToMainBtn: "다음 단계로",
        },
      },
      createSiteModal: {
        title: "사이트 만들기",
        siteName: "사이트 이름",
        siteUrl: "사이트 URL",
        siteId: "사이트 ID",
        siteNameCheckMsg: "사이트 이름은 최대 {0}자 이내로 입력해주세요.",
        siteUrlCheckMsg: "사이트 URL은 최대 {0}자 이내로 입력해주세요.",
        siteIdCheckMsg: "사이트 ID는 최대 {0}자 이내로 입력해주세요.",
        aleadyExistUser:
          "현재 계정은 Wrapsody 또는 Fireside 사이트에 등록되어 있어 신규 사이트 생성이 불가능합니다. 기존 사이트에서 탈퇴 또는 계정 삭제 후 다시 시도해 주세요.",
        tooltip: {
          siteId: "사이트 ID는 최초 설정 후 변경할 수 없습니다.",
          siteUrl: "URL은 최초 설정 후 변경할 수 없습니다.",
        },
        placeholder: {
          siteName: "사이트 이름을 입력하세요.",
          siteId: "사이트 생성을 위한 ID를 입력하세요.",
        },
        alert: {
          validAddress: "사용할 수 있는 주소입니다.",
          invalidAddress: "사용할 수 없는 주소입니다.",
          validId: "사용할 수 있는 ID입니다.",
          invalidId: "영문 소문자와 숫자만 포함할 수 있습니다.",
          isDuplicate: "이미 존재합니다.",
        },
        serverLocation: {
          fieldname: "서버 생성 위치",
          option_1: "아시아 태평양 (서울)",
          option_2: "미국 동부 (버지니아 북부)",
        },
        validAddress: "사용할 수 있는 주소입니다.",
        suffix: {
          eco: ".wrapsodyeco.com",
          wrapsody: ".wrapsody.com",
          ociEco: "cloud.wrapsodyeco.com/",
          ociWrapsody: "cloud.wrapsody.com/",
        },
      },
      createSite: {
        createStatus: "현재 사이트 생성 중입니다.",
        createStatusStart:
          "사이트 생성 중입니다. 잠시만 기다려주세요.\n사이트 생성 후 서비스 구동까지 10분 정도 시간이 소요될 수 있습니다. 해당 작업이 완료되면 등록하신 email 계정으로 관리자 계정 ID 및 임시 비밀번호가 전송됩니다.",
        createStatusComplete: "사이트 생성이 완료되었습니다.",
        goAdminPageBtn: "관리자 페이지",
        goUserPageBtn: "사용자 페이지",
        delete: "사이트 삭제",
        detail: {
          title: "기본 정보",
          siteName: "사이트 이름",
          goToEdit: "변경",
          siteAddress: "사이트 주소",
          currentUser: "현재 사용자",
          maxUser: "최대 사용자",
          createDate: "사이트 생성일",
          lastAccessDate: "최근 접속일",
          serverLocation: "서버 생성 위치",
          storage: {
            fieldname: "용량",
            byteUnit: "GB",
            usage: "사용",
            usageMsg: "{0} 중 {1} 사용",
            info: "용량이 부족할 경우 신규 문서 생성 및 리비전 등 일부 기능이 동작하지 않습니다.\n업그레이드를 통해 라이선스를 추가 구매하여 용량을 확보하세요.",
            info_fireside:
              "용량이 부족할 경우 채팅창에 파일을 보낼 수 없습니다.\n업그레이드를 통해 라이선스를 추가 구매하여 용량을 확보하세요.",
            unlimit: "무제한",
          },
        },
        createStepMsg_1: "생성 완료",
        createStepMsg_2: "저장 공간을 할당 중입니다.",
        createStepMsg_3: "사이트를 초기화하는 중입니다.",
        createStepMsg_4: "사이트 개설에 필요한 정보를 가져오는 중입니다.",
        createStepMsg_5: "사용자가 설정한 정보를 반영하는 중입니다.",
        createStepMsg_6: "문서 암호화에 필요한 암호키를 생성하는 중입니다.",
        createStepMsg_7: "사이트를 시작하는 중입니다.",
        createStepMsg_8: "설정하신 URL의 배포를 기다리고 있습니다.",
        siteCreatedTitle: "생성 완료",
        siteCreatedBody: "사이트 생성이 완료되었습니다.",
        siteCreatedDesc: {
          eco: "관리자 페이지로 이동하여 Wrapsody eCo를 이용해보세요.",
          wrapsody: "사용자 페이지로 이동하여 Wrapsody를 이용해보세요.",
        },
      },
      popup: {
        change: {
          siteName: "사이트 이름 변경",
          enterSiteName: "변경할 사이트 이름을 입력하세요.",
          siteAddress: "사이트 주소 변경",
          newName: "새 이름",
        },
        delete: {
          title: "사이트 삭제",
          info: "사이트를 정말 삭제하시겠습니까?",
          subInfo:
            "사이트 삭제 시 데이터가 완전히 삭제되어 복구 할 수 없습니다.",
          subInfo1:
            "사이트 삭제 시 30일 동안 임시 보관되며 백업 가능합니다.\n30일 이후에는 완전히 삭제되어 복구할 수 없습니다.",
        },
        guide: {
          title: "가이드 다운로드",
          download:
            "https://www.wrapsodyeco.com/pdf/kr/Wrapsody_eCo_v2.4_관리자_가이드.pdf",
          downloadAdmin: "관리자 가이드 다운로드",
          moveAdmin: "관리자 페이지로 이동",
          msg1: "Wrapsody eCo 사용법이 궁금하신가요?",
          msg2: "관리자 가이드 확인 후에 이동하시기를 추천합니다.",
          close30Days: "30일 동안 열지 않음",
        },
      },

      paymentHistory: {
        title: "구매이력",
        selectSiteBtn: "사이트 선택",
        paymentManagement: {
          title: "요금제 관리",
          resubscription: "해지 취소하기",
          resumeSubscription: "구독 재개하기",
          resumeSubscriptionNewCard: "카드 교체 후 구독 재개하기",
          cancelSubscription: "정기결제 해지",
          payment: "요금제",
          user: "사용자",
          paymentCycle: "결제 주기",
          maxStorage: "최대 용량(GB)",
          startDate: "사이트 개설",
          endDate: "사이트 만료",
          unlimited: "-",
        },
        payment: {
          title: "결제 수단",
          add: "결제 수단 추가",
          change: "결제 수단 변경",
          cash: "현금",
          card: "카드",
          coupon: "쿠폰",
        },
        history: {
          title: "결제 이력",
          paymentSystem: "요금제",
          date: "결제일자",
          license: "라이선스",
          cardInformation: "결제 카드 정보",
          fee: "요금",
          progressState: "진행 상태",
          bill: "청구서",
          disagree: "정기 결제 미동의로 자동 환불",
          subscriptionInfo: "구독 정보",
          period: "구독 기간",
          failState: "결제 실패",
          failState1: "결제 실패(1회) ",
          failState2: "결제 실패(2회)",
          failState3: "결제 실패(3회)",
          successState: "결제 성공",
        },
        popUp: {
          changeSiteType: {
            title: "요금제 변경",
            Msg1: "더 낮은 요금제로 변경하려면 ",
            Msg2: "문의하기",
            Msg3: "를 이용하십시오.",
            basicToPlus: {
              eco: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 : {0} ",
                    Msg3_1:
                      "(요금 차액(Plus 요금- Basic 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Plus 요금 청구) : {1}{2}",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 : {0}{1}",
                    Msg3_1:
                      "(요금 차액(Plus 요금- Basic 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Plus 요금 청구) : {1}{2}",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
              wrapsody: {
                USD: {
                  info: {
                    annual: {
                      Msg1: "결제 주기 : 연 1회",
                      Msg2: "사용 인원 : {0} 명",
                      Msg3: "차액 즉시 결제 금액 {0} USD",
                      Msg3_1:
                        "(요금 차액(Enterprise 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                      Msg4: "변경된 연간 구독료 ({0}부터 Enterprise 요금 청구) {1} USD",
                      Msg5: "* 부가세 10% 별도",
                    },
                    monthly: {
                      Msg1: "결제 주기 : 매월",
                      Msg2: "사용 인원 : {0}명",
                      Msg3: "차액 즉시 결제 금액 {0} USD",
                      Msg3_1:
                        "(요금 차액(Enterprise 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                      Msg4: "변경된 월 구독료 ({0}부터 Enterprise 요금 청구) {1} USD",
                      Msg5: "* 부가세 10% 별도",
                    },
                  },
                },
                KRW: {
                  info: {
                    annual: {
                      Msg1: "결제 주기 : 연 1회",
                      Msg2: "사용 인원 : {0} 명",
                      Msg3: "차액 즉시 결제 금액 ￦ {0}",
                      Msg3_1:
                        "(요금 차액(Enterprise 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                      Msg4: "변경된 연간 구독료 ({0}부터 Enterprise 요금 청구) ￦ {1}",
                      Msg5: "* 부가세 10% 별도",
                    },
                    monthly: {
                      Msg1: "결제 주기 : 매월",
                      Msg2: "사용 인원 : {0}명",
                      Msg3: "차액 즉시 결제 금액 ￦ {0}",
                      Msg3_1:
                        "(요금 차액(Enterprise 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                      Msg4: "변경된 월 구독료 ({0}부터 Enterprise 요금 청구) ￦ {1}",
                      Msg5: "* 부가세 10% 별도",
                    },
                  },
                },
              },
            },
            basicTobasicPlus: {
              USD: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(요금 차액(Standard Plus 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Standard Plus 요금 청구) {1} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(요금 차액(Standard Plus 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Standard Plus 요금 청구) {1} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
              KRW: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(요금 차액(Standard Plus 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Standard Plus 요금 청구) ￦ {1}",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(요금 차액(Standard Plus 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Standard Plus 요금 청구) ￦ {1}",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
            },
            basicToplusPlus: {
              USD: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Enterprise Plus 요금 청구) {1} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Enterprise Plus 요금 청구) {1} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
              KRW: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Enterprise Plus 요금 청구) ￦ {1}",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Standard 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Enterprise Plus 요금 청구) ￦ {1}",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
            },
            basicPlusToplusPlus: {
              USD: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Standard Plus 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Enterprise Plus 요금 청구) {1} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Standard Plus 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Enterprise Plus 요금 청구) {1} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
              KRW: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Standard Plus 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Enterprise Plus 요금 청구) ￦ {1}",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Standard Plus 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Enterprise Plus 요금 청구) ￦ {1}",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
            },
            plusToplusPlus: {
              USD: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Enterprise 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Enterprise Plus 요금 청구) {1} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Enterprise 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Enterprise Plus 요금 청구) {1} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
              KRW: {
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0} 명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Enterprise 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 Enterprise Plus 요금 청구) ￦ {1}",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(요금 차액(Enterprise Plus 요금- Enterprise 요금) × 사용 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 Enterprise Plus 요금 청구) ￦ {1}",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
            },
            toPremium: {
              info: {
                Msg1: "프리미엄 요금제는 사용자가 지정하는 용량 및 외부 사용자 수에 따라 요금이 결정됩니다. 결제는 별도의 안내를 통해 진행됩니다. ",
              },
            },
          },
          changeNumberOfUsers: {
            title: "사용 인원 변경",
            beforeChange: "변경 전 사용자 수",
            afterChange: "변경 후 사용자 수",
            changeNumberUserMsg:
              "추가 사용자 수는 최소 0명에서 최대 {0}명까지 지정 가능합니다.",
            Msg1: "사용 인원을 줄이기 위해서는 ",
            Msg2: "문의하기",
            Msg3: "를 이용하십시오.",
            Msg4: "상기 변경 사항 및 결제 금액에 동의합니다.",
            eco: {
              info_1: "기존 연간 결제 금액은 US",
              info_2: "(사용자 {0}명 기준)입니다.",
              info_3: "기존 월간 결제 금액은 US",
              info_4: "(사용자 {0}명 기준)입니다.",
              info_5: "변경된 연간 결제 예상 금액은 US",
              info_6: "(사용자 {0}명 기준)입니다.",
              info_7: "변경된 월간 결제 예상 금액은 US",
              info_8: "(사용자 {0}명 기준)입니다.",

              info: {
                annual: {
                  Msg1: "결제 주기 : 연 1회",
                  Msg2: "사용 인원 : {0}명",
                  Msg3: "차액 즉시 결제 금액 : {0}{1}",
                  Msg3_1:
                    "(년 구독료 × 추가 인원) / 365 × 다음 청구일까지 잔여 일",
                  Msg4: "변경된 연간 구독료 ({0}부터 {1}명 요금 청구) {2}{3}",
                  Msg5: "* 부가세 10% 별도",
                },
                monthly: {
                  Msg1: "결제 주기 : 매월",
                  Msg2: "사용 인원 : {0}명",
                  Msg3: "차액 즉시 결제 금액 : {0}{1}",
                  Msg3_1:
                    "(월 구독료 × 추가 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                  Msg4: "변경된 월 구독료 ({0}부터 {1}명 요금 청구) {2}{3}",
                  Msg5: "* 부가세 10% 별도",
                },
              },
            },
            wrapsody: {
              USD: {
                info_1: "기존 연간 결제 금액은 US",
                info_2: "(사용자 {0}명 기준)입니다.",
                info_3: "기존 월간 결제 금액은 US",
                info_4: "(사용자 {0}명 기준)입니다.",
                info_5: "변경된 연간 결제 예상 금액은 US",
                info_6: "(사용자 {0}명 기준)입니다.",
                info_7: "변경된 월간 결제 예상 금액은 US",
                info_8: "(사용자 {0}명 기준)입니다.",
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(년 구독료 × 추가 인원) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 {1}명 요금 청구) {2} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 {0} USD",
                    Msg3_1:
                      "(월 구독료 × 추가 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 {1}명 요금 청구) {2} USD",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
              KRW: {
                info_1: "기존 연간 결제 금액은 ￦",
                info_2: "(사용자 {0}명 기준)입니다.",
                info_3: "기존 월간 결제 금액은 ￦",
                info_4: "(사용자 {0}명 기준)입니다.",
                info_5: "변경된 연간 결제 예상 금액은 ￦",
                info_6: "(사용자 {0}명 기준)입니다.",
                info_7: "변경된 월간 결제 예상 금액은 ￦",
                info_8: "(사용자 {0}명 기준)입니다.",
                info: {
                  annual: {
                    Msg1: "결제 주기 : 연 1회",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(년 구독료 × 추가 인원) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 연간 구독료 ({0}부터 {1}명 요금 청구) ￦ {2}",
                    Msg5: "* 부가세 10% 별도",
                  },
                  monthly: {
                    Msg1: "결제 주기 : 매월",
                    Msg2: "사용 인원 : {0}명",
                    Msg3: "차액 즉시 결제 금액 ￦ {0}",
                    Msg3_1:
                      "(월 구독료 × 추가 인원 × 12) / 365 × 다음 청구일까지 잔여 일",
                    Msg4: "변경된 월 구독료 ({0}부터 {1}명 요금 청구) ￦ {2}",
                    Msg5: "* 부가세 10% 별도",
                  },
                },
              },
            },
          },
          changePaymentCycle: {
            title: "결제 주기 변경",
            payType_month: "매달 결제",
            payType_annual: "연 1회 결제",
            basis: "1인 기준",
            annualPrice: "1인당 연간 {0}{1}",
            annualPrice_1: "1인당 연간 US${0}",
            info: {
              Msg1: "{0} 부터 변경된 결제 주기가 적용된 요금이 청구됩니다.",
              Msg2: "매달 결제로 변경시 매월 청구 요금은 {0}{1}입니다.",
              Msg3: "연 1회 결제로 변경시 매년 청구 요금은 {0}{1}입니다.",
              Msg4: "* 부가세 10% 포함", // 2024-12-16 별도 -> 포함
            },
            annualPrice_2: "1인당 연간 ￦{0}",
            info_2: {
              Msg1: "{0} 부터 변경된 결제 주기가 적용된 요금이 청구됩니다.",
              Msg2: "매달 결제로 변경시 매월 청구 요금은 ￦{0}입니다.",
              Msg3: "연 1회 결제로 변경시 매년 청구 요금은 ￦{0}입니다.",
              Msg4: "* 부가세 10% 별도",
            },
            month12: "12개월",
          },
        },
        bill: {
          inquiry: "문의하기",
          address: {
            address_1: "서울 마포구 월드컵북로 396",
            detailedAddress:
              "(상암동 1605, 누리꿈스퀘어 비즈니스타워 6층, 17층)",
            postalCode: "[03925]",
            vatId: "VAT ID: IE 9852817J",
            email: "helpdesk@fasoo.com",
          },
          detail: {
            title: "청구서",
            printBtn: "인쇄",
            billingTo: "청구 대상",
            paymentMethod: "결제 수단",
            paymentDate: "결제일",
            id: "청구서 ID",
            payType: "요금제",
            user: "사용자",
            expirationDate: "기한",
            price: "금액",
            total: "합계",
            info: "표시된 모든 금액은 미국 달러(USD)가 기준입니다.",
            includeVat: "부가세 10% 포함",
          },
        },
      },
    },

    admin: {
      common: {
        logout: "로그아웃",
        alert: {
          invalidData: {
            request_freeTrial: "무료 서비스 신청 내역이 없습니다.",
            request_coupon: "쿠폰 신청 내역이 없습니다.",
            search: "검색 결과가 없습니다.",
          },
          success: {
            added: "추가 되었습니다.",
            edited: "수정 되었습니다.",
            deleted: "삭제 되었습니다.",
          },
          check: {
            enterPeriod: "기간을 입력하세요.",
            enterLicense: "내부 사용자 수를 입력하세요.",
            enterExternalLicense: "사용자당 외부 사용자 수를 입력하세요.",
            enterStorage: "사용자당 용량을 입력하세요.",
            enterValidity: "쿠폰 유효 기간을 입력하세요.",
            enterCompany: "회사명을 입력하세요.",
            enterPurpose: "발급 사유를 입력하세요.",
          },
          login: {
            enterOtp: "이메일로 발송된 인증 번호를 입력해주세요.",
            enterUserId: "아이디를 입력하세요.",
            enterPassword: "비밀번호를 입력하세요.",
            error: "에러가 발생하였습니다.",
          },
        },
      },
      login: {
        title: "관리자 로그인",
        id: "아이디",
        password: "비밀번호",
        otp: {
          sendBtn: "인증번호 이메일 전송",
          enterMsg: "인증번호 입력",
          goToLoginBtn: "관리자 로그인",
          enterMsgAdmin: "인증번호를 입력해주세요.",
          copy: "복사",
        },
      },
      portal_dashboard: "대시보드",
      portal_site: "사이트 관리",
      portal_license: "라이선스 관리",
      portal_price: "결제 관리",
      portal_coupon: "쿠폰 관리",
      portal_trial: "무료 체험 관리",
      portal_notification: "공지 관리",
      portal_user: "사용자 관리",
      portal_admin_assignment: "관리자 관리",
      portal_fasoo_dto_stat: "eCo DTO 통계",
      portal_finance: "파수 재무팀",
      portal_QnA: "Q/A 관리",
      dashboard: {
        //대시보드
        total: "전체",
        new: "전일 신규",
        register: "신청 현황",
        members: {
          title: "사용자",
          cancel: "탈퇴",
          register: "가입",
          total: "총인원",
        },
        site: {
          title: "사이트",
          delete: "삭제",
          create: "생성",
          total: "총 개수 ",
        },
        subscription: {
          free: {
            type: "무료체험",
            reject: "거절",
            approve: "승인",
            register: "신청",
          },
          premium: {
            type: "프리미엄",
            reject: "거절",
            approve: "승인",
            register: "신청",
            coupon: "프리미엄 코드 생성",
          },
        },
        storage: {
          title: "스토리지 사용 현황",
          usage: "사용 용량(GB)",
        },
        budget: {
          title: "매출 현황",
          cancel: "취소",
          pay: "결제",
        },
      },
      siteMgnt: {
        endDate: "",
        manager: "",
        filter: "검색 조건",
        userName: "고객명",
        userId: "고객 ID",
        subscriptionType: {
          title: "상태",
          all: "전체",
          select: "선택",
          freeTrial: "무료체험",
          premium: "Premium",
          paid: "유료",
        },
        domain: "도메인명",
        region: {
          title: "리전 주소",
          america: "북미",
          asia: "아시아 태평양",
        },
        subscriptionStatus: {
          title: "구독 유형",
          all: "전체",
          select: "선택",
          active: "구독 중", //정상
          unsubscribed: "취소 접수", //취소중
          mercyPeriod: "구독 만료", //만료
          deactivated: "종료",
          normal: "정상",
          suspended: "정지 중",
          ended: "종료",
        },
        siteStatuses: {
          service: "정상",
          ready: "사이트 배포 준비",
          fail: "사이트 배포 실패",
          restart: "사이트 재시작 필요",
        },
        search: "검색",
        no: "No",
        url: "URL",
        serviceName: "사이트명",
        serverLocation: "서버위치",
        createDate: "사이트 생성",
        subscriptionDate: "구독 시작",
        subscriptionEndDate: "구독 종료",
        type: "요금제",
        serviceStatus: "상태",
        siteStatus: "사이트 상태",
        user: "사용자",
        payment: "결제 금액",
        detail: "상세정보",
        details: {
          manageService: "사이트 관리",
          active: "시작",
          deactive: "운영 중단",
          terminate: "종료",
          serviceName: "사이트명",
          subscriptionType: "서비스 종류",
          subscriptionDate: "구독 시작",
          createDate: "사이트 생성",
          expirationDate: "사이트 종료",
          user: "사용자",
          storage: "사용량(GB) / 전체(GB)",
          license: "내부사용자 수",
          externalLicense: "외부사용자 수",
          bucketName: "S3 버킷명",
          paymentHistory: {
            history: "결제 이력",
            subscription: "요금제",
            nextPayment: "다음 결제일",
            paymentTerm: "결제 주기",
            license: "사용자",
            storage: "용량 (GB)",
            code: "구독 정보",
            price: "요금",
            paymentDate: "결제일자",
            period: "구독 기간",
            disagree: "미동의",
          },
          startInfo: `사이트를 시작하려면 'start'를 입력하세요.`,
          stopInfo: `사이트 운영을 중단하려면 'stop'을 입력하세요.`,
          terminateInfo: `사이트를 삭제하려면 'terminate'를 입력하세요.`,
        },
      },
      couponMgnt: {
        registrationInfo: {
          title: "신청 정보",
          no: "번호",
          code: "프리미엄 코드",
          license: "내부 사용자 라이선스 (명)",
          externalLicense: "외부 초대 인원 라이선스 (명)",
          userStorage: "사용자 당 용량 (GB)",
          company: "사용 기관",
          purpose: "발급 사유",
          period: "기간",
          days: "일",
          applicant: "신청자",
          registerDate: "신청일",
          approve: "발급",
          issue: "발급",
          noIssue: "발급 안함",
          reject: "거절",
          rejectReason: "거절 사유",
        },
        issued: {
          title: "발급 내역",
          no: "No.",
          code: "Code",
          period: "기간(일)",
          license: "라이선스 (명)",
          externalLicense: "외부 라이선스 (명)",
          storage: "사용자당 용량 (GB)",
          expirationDate: "유효기간",
          company: "고객사명",
          purpose: "발급 사유",
          admin: "발급자",
          date: "발급일",
          usageDate: "사용일",
          select: "선택",
          all: "전체",
          used: "사용",
          unused: "미사용",
          request: "요청쿠폰",
          reject: "거절",
          rejectMsg: "쿠폰 거절",
          addBtn: "쿠폰 등록",
          totalStorage: "총 스토리지 용량 (GB)",
          subscriptionType: {
            freeTrial: "무료",
            premium: "프리미엄",
            paid: "유료",
          },
          siteStatus: "요금 / 상태 / URL",
        },
      },
      cashMgnt: {
        list: "현금 결제 신청 내역",
        status: {
          wait: "현금 결제 요청",
          apply: "입금 확인 요청",
          approved: "승인",
          done: "사이트 생성 완료",
          reject: "관리자 거부",
          cancel: "요청자 취소",
        },
        issued: {
          depositor: "입금자명",
          userAdmin: "사이트 관리자",
          price: "총 금액",
          checkdate: "입금 승인/거절일",
          updateAdmin: "상태/수정자",
        },
        acceptRequest: "입금 확인",
        rejectRequest: "입금 거절",
      },
      freeTrialMgnt: {
        pending: "신청내역",
        approved: "승인내역",
        name: "이름",
        account: "계정",
        phoneNumber: "전화번호",
        company: "회사",
        purpose: "신청 사유",
        reject: "거절",
        approve: "승인",
        requestDate: "신청일",
        approvedDate: "승인(거절)일",
        approver: "승인(거절)자",
        rejectReason: "거절 사유",
        rejectMsg: "무료체험 거절",
        approvalStatus: {
          select: "선택",
          all: "전체",
          approve: "승인",
          reject: "거절",
          deleted: "삭제",
        },
        subscriptionType: {
          freeTrial: "무료",
          premium: "프리미엄",
          paid: "유료",
        },
        siteStatus: "요금/상태/URL",
      },
      notificationMgnt: {
        current: "현재 공지 사항",
        none: "없음",
        list: "공지사항 목록",
        no: "No.",
        email: "메일 발송",
        startDate: "시작일",
        endDate: "종료일",
        notification_ko: "공지 내용 (국문)",
        notification_en: "공지 내용 (영문)",
        okBtn: "완료",
      },
      userMgnt: {
        filter: "검색 조건",
        userName: "사용자 이름",
        userId: "사용자 ID",
        userType: "사용자 유형",
        userEmail: "Email",
        loginTime: "마지막 로그인",
        entryTime: "등록 일시",
        email: "Email",
        search: "검색",
        export: "엑셀 내보내기",
        excelName: "eCo Cloud 사용자 리스트",
      },
      adminMgnt: {
        id: "관리자 ID",
        permission: "권한 범위",
        entryDate: "등록 일시",
        updateDate: "수정 일시",
        addBtn: "등록",
        modifyBtn: "수정",
        deleteBtn: "삭제",
        modify: "관리자 권한 수정",
        add: "관리자 등록",
      },
      stat: {
        totalStat: "종합 통계",
        wgDocStat: "워크그룹 / 문서 통계",
        workgroupList: "워크그룹 리스트",
        documentsLog: "파일 사용 로그",
        wgStat: "워크그룹 통계",
        year: "년",
        month: "월",
        count: "개",
        cnt: "개",
        overCnt: "개 이상",
        include: "포함",
        exclude: "미포함",
        workgropuCount: "워크그룹 수",
        workgroupCreateCount: "워크그룹 생성 수",
        docCreateCount: "문서 생성 수",
        docUsageCount: "문서 사용 수",
        memberCount: "멤버 수",
        search: "검색",
        export: "엑셀 내보내기",
        workgroupName: "워크그룹 이름",
        manager: "워크그룹장",
        managerDept: "워크그룹장 부서",
        createDate: "생성일",
        docCount: "공유 문서 수",
        status: "상태",
        internalUser: "내부 사용자",
        externalUser: "외부 사용자",
        storageUse: "사용 용량",
        dateTime: "사용 일시",
        fileName: "파일 이름",
        version: "버전",
        userName: "사용자 이름",
        userId: "사용자 ID",
        deptName: "부서 이름",
        deptManagerName: "부서장",
        type: "사용 유형",
        view: "열람",
        revise: "리비전",
        download: "다운로드",
        create: "생성",
        active: "사용중",
        delete: "삭제",
        ip: "IP",
        agent: {
          name: "플랫폼",
          1: "Windows",
          2: "Mac",
          3: "Web",
          4: "Mobile",
          5: "Outlook",
          6: "FXM",
          0: "N/A",
        },
        updateInfo:
          "데이터(공유 문서 수, 사용 용량)는 매일 01시에 업데이트 됩니다.",
        enterWorkgroupManager: "워크그룹 그룹장 이름 또는 ID",
        enterUserNameOrID: "사용자 이름 또는 ID",
        retiree: "퇴사자",
        all: "전체",
        chart: "차트",
      },
      upc: {
        site: {
          applicationName: "지원 애플리케이션 이름",
          applicationModal: "지원 애플리케이션",
          detailBtn: "지원 정보 보기",
          process: "프로세스명",
          extension: "UPC 적용 확장자",
          selectedApp: "선택된 애플리케이션",
          applicationEditModal: "지원 애플리케이션 수정",
          enterDeposit: "입금자명을 입력해주세요.",
          upcSelectLimit: `더 많은 애플리케이션을 선택하려면 Wrapsody eCo Cloud 웹사이트(
                <a href='https://wrapsodyeco.com/kr/inquiry' target='_blank'>
                  wrapsodyeco.com/kr/inquiry
                </a>
              )에서 문의를 남겨주세요.`,
        },
        countProcess: `{0}외 {1}개`,
        modal: {
          title: "대표 애플리케이션",
          AddApp: "대표 애플리케이션 등록",
          modifyApp: "대표 애플리케이션 수정",
          insertAppName: "대표 애플리케이션 이름을 입력하십시오.",
          upcExt: "UPC 적용 확장자",
          insertProcessName: "프로세스명을 입력하시오.",
          insertUpcExt:
            "UPC 적용 확장자는 exe,ttt,ssss,rrr 형식으로 입력해 주세요.",
          alert: {
            add: "모든 정보 입력 후 추가가 가능합니다.",
            enterReuired: "필수 입력란을 입력하십시오.",
            editSuccess: "수정 완료",
            addSuccess: "추가 완료",
            deleteSuccess: "삭제 완료",
            confirmDelete: "해당 애플리케이션을 삭제하시겠습니까?",
            onlyEngProcess: "Process명에는 영문만 입력 가능합니다.",
            onlyEngExt: "확장자에는 영문만 입력 가능합니다.",
          },
        },
      },
    },
    cashStatus: {
      pay_cash: "현금 결제",
      complete: "현금 결제 완료",
      changeToCard: "카드로 교체",
      waitNotice:
        "현재 관리자에게 현금 요청 승인을 기다리는 중입니다. 결제 요청 취소를 하고 싶으면 버튼을 눌러주세요.",
      requestNotic:
        "관리자에게 성공적으로 요청되었습니다. 빠른 시일내에 확인하여 알려드리겠습니다.",
      //receiverPlaceholder: "입금자명을 정확하게 입력하시오",
      requestCash: "현금 결제를 선택하셨습니다.",
      chooseApp: "희망 애플리케이션 선택",
      chooseSolution: "희망 솔루션 선택",
      chooseAppUntilThree:
        "해당 요금제는 애플리케이션 최대 3개까지 선택 가능합니다.",
      chooseAppFour: "해당 요금제는 애플리케이션 최소 4개부터 선택 가능합니다.",
      history: "현금 결제 이력",
      requestCashCheck:
        "아래 내용을 확인하시고 입금하신 후 [입금 확인 요청] 버튼을 눌러주세요.",
      checkEmail: "최대한 빠른 시일 내에 확인하여 이메일로 알려드리겠습니다.",
      requestPayment: "결제 입금 확인 요청",
      removePayment: "결제 취소",
      removeSuccess: "결제 취소 완료",
      removeModal: {
        removePaymentReason: "결제 취소 사유를 적어주세요.",
        removePaymentMsg: "결제 취소 사유",
      },
      pay: {
        bank: "입금은행",
        account: "계좌번호",
        receiver: "받으시는 분",
        totalPrice: "금액",
        sender: "입금자명",
      },
      taxInvoice: {
        title: "세금 계산서",
        owner: "대표자명",
        businessNumber: "사업자 등록 번호",
        requestDate: "발행 요청 일자",
        issuer: "청구서 담당자 이름",
        phoneNumber: "청구서 담당자 전화 번호",
        email: "청구서 담당자 이메일",
        placeHolder: {
          owner: "대표자 이름을 입력해주세요.",
          businessNumber: "사업자 등록 번호를 입력해주세요.",
          requestDate: "발행 요청 일자를 입력해주세요.",
          issuer: "청구서 담당자 이름을 입력해주세요.",
          phoneNumber: "청구서 담당자 전화 번호를 입력해주세요.",
          email: "청구서 담당자 이메일을 입력해주세요.",
        },
      },
    },
  },
});

export const forceSetLanguage = () => {
  let defaultLang = "ko";

  // console.log('lang_path', lang)

  // if (typeof navigator === 'undefined') {
  //   return defaultLang
  // } else if (lang === 'en') defaultLang = 'en-US'
  // else if (!!navigator && !!navigator.languages && !!navigator.languages[0]) {
  //   defaultLang = navigator.languages[0]
  //   // return
  // } else if (!!navigator && !!navigator.language) {
  //   defaultLang = navigator.language
  // } else if (!!navigator && !!navigator.userLanguage) {
  //   defaultLang = navigator.userLanguage
  // } else if (!!navigator && !!navigator.browserLanguage) {
  //   defaultLang = navigator.browserLanguage
  // }

  const lang = getLanguage();

  if (lang === "ko") defaultLang = "ko-KR";
  else if (lang === "en") defaultLang = "en-US";
  return defaultLang;
};

export const getLanguage = () => {
  // const lang = window.location.pathname.split("/")[1];
  const lang = i18n.language;

  return lang;
  // return "en";
};

// 언어라우팅 초기 세팅 (2023-11-07)
export const languageRouteInit = () => {
  const pathname = window.location.pathname;
  const pathArr = window.location.pathname.split("/");
  let defaultLang = "en-US";
  const Navigator: any = navigator;
  if (typeof Navigator === "undefined") {
    return defaultLang;
  }
  defaultLang = forceSetLanguage();
  localStrings.setLanguage(defaultLang);
  // url에 ko나 en이 없는 경우
  if (!pathArr.includes("ko") && !pathArr.includes("en")) {
    // console.log("없냐?", pathArr);
    if (typeof navigator === "undefined") {
      return defaultLang;
    }
    if (!!navigator && !!navigator.languages && !!navigator.languages[0]) {
      defaultLang = navigator.languages[0];
      // return
    } else if (!!Navigator && !!Navigator.language) {
      defaultLang = Navigator.language;
    } else if (!!Navigator && !!Navigator.userLanguage) {
      defaultLang = Navigator.userLanguage;
    } else if (!!Navigator && !!Navigator.browserLanguage) {
      defaultLang = Navigator.browserLanguage;
    }
    localStrings.setLanguage(defaultLang);
    // localStrings.setLanguage("en-US");
    console.log("defaultLang test", defaultLang);
    if (defaultLang === "en-US") defaultLang = "en";
    else if (defaultLang === "ko-KR") defaultLang = "ko";
    // console.log(`${process.env.PUBLIC_URL}`)
    // console.log(`${defaultLang}/${pathname}`)
    // window.location.href = `${
    //   import.meta.env.PUBLIC_URL
    // }/${defaultLang}${pathname}`;

    // window.location.href = `/${defaultLang}${pathname === "" ? "/" : pathname}`;
    window.location.href = `/${defaultLang}`;
  }
};
